import "./App.css";
import { useEffect, useRef, useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import howitworksContent from "../src/images/Component.png";
import howitworksContent1 from "../src/images/Component (1).png";
import howitworksContent2 from "../src/images/Component (2).png";
import howitworksContent3 from "../src/images/Component (3).png";
import howitworksContent4 from "../src/images/Component (4).png";
import axios from "axios";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Lottie from "lottie-react";
import scrollDown from "../src/json/Scroll down.json";
import scrolldown from "../src/json/scrooldown.json";
import success from "../src/json/success.json";
import joinJson from "../src/json/CTA DASHBOARD.json";
import allcardjson from "../src/json/New All Card Update.json";
import { LottieComponent } from "./Components/LottieComponent";
import "react-tooltip/dist/react-tooltip.css";
import { Tooltip } from "react-tooltip";
import fiveKey from "../src/images/image 2236.png";
import coin from "../src/images/coin.png";
import googleplay from "../src/images/Google_Play_Store_badge_EN 1.png";
import appstore from "../src/images/US_UK_Download_on_the.png";
import AnimatedCards from "./Components/IntersectedAnimatedCards";
import listImg from "../src/images/list.png";
import rentImg from "../src/images/rent.png";
import investImg from "../src/images/invest.png";
import tradeImg from "../src/images/trade.png";
import rentVideo from "../src/video/Rent.mp4";
import manageVideo from "../src/video/Manage.mp4";
import listVideo from "../src/video/List and Buy.mp4";
import investVideo from "../src/video/Invest.mp4";
import leverageVideo from "../src/video/Trade.mp4";
import BookVideo from "../src/video/Book.mp4";
import rentalVideo from "../src/video/Rental.mp4";
import yieldEstateVideo from "../src/video/YieldEstate.mp4";
import rwaPerps from "../src/video/RWA Preps.mp4";
import marketVideo from "../src/video/Marketplace.mp4";
import AiVideo from "../src/video/Ai.mp4";
import TradeVideo from "../src/video/Trade1.mp4";
import Ai1 from "../src/video/Ai1.mp4";

import { VideoComponent } from "./Components/VideoComponent";
import Topbar from "./Components/TopBar";
import Card from "./Components/Card";
import LiveSvg from "./Components/LiveSvg";
import ModalSvg from "./Components/ModalSvg";
import BookNow2 from "./Components/BookNow2";
import Line from "./Components/Line";
import Coded from "./Components/Coded";
import Arrow from "./Components/Arrow";
import CodedEstate from "./Components/CodedEstate";
import Flag from "./Components/Flag";
import Flag2 from "./Components/Flag2";
import SecondFloatingAlert from "./Components/SecondFloatingAlert";
import { SubmitYourWallet } from "./Components/SubmitYourWallet";
import { WalletSubmitModal } from "./Components/WalletSubmitModal";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import circle from "./images/circle.svg"
// import perps from "./images/perps.svg";
// import bookinghotel from "./images/hotel-booking.svg";
// import rentalplace from "./images/rental-place.svg";

// const handleNavigation = (url) => {
//   window.location.href = url;
// };


function App() {
  const [index, setIndex] = useState(0);
  const [menu, setMenu] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [position, setPosition] = useState(0);
  const [join, setJoin] = useState(false);
  const [comingshow, setComingshow] = useState(true);
  const sliderRef = useRef(null);
  const [joinflag, setJoinFlag] = useState(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [joinString, setJoinString] = useState("Joined to waitlist!");
  const [form, setForm] = useState({
    Email: null,
    Name: null,
  });
  const [depositAlert, setDepositAlert] = useState(false);
  const [Notification, setNotification] = useState(true);
  const [bookNowAlert, setBookNowAlert] = useState(false);
  const [walletModalOpen, setWalletModalOpen] = useState(false);
  const [connectedWallet, setConnectedWallet] = useState(null);
  const [isAnyModalOpen, setIsAnyModalOpen] = useState(false);
  useEffect(() => {
    if (/Mobile|Android/i.test(navigator.userAgent)) {
      console.log("This is a mobile device");
      setMenu(true);
    } else {
      console.log("This is a desktop device");
      setMenu(false);
    }
  }, []);

  useEffect(() => {
    // setTimeout(() => {
    //   setJoin(true);
    // }, 5000);
    setLoaded(true);
  }, []);

  useEffect(() => {
    window.addEventListener("click", () => {
      if (window.innerWidth < 400) setMenu(true);
    });

    window.addEventListener("scroll", () => {
      const owntop = document.getElementById("own").getBoundingClientRect().top;
      const selltop = document
        .getElementById("sell")
        .getBoundingClientRect().top;
      const tradetop = document
        .getElementById("trade")
        .getBoundingClientRect().top;
      const howtop = document
        .getElementById("howItWorks")
        .getBoundingClientRect().top;
      setPosition(0);
      if (owntop < 110) setPosition(1);
      if (selltop < 110) setPosition(2);
      if (tradetop < 110) setPosition(3);
      if (howtop < 110) setPosition(4);
    });
  }, []);

  const handleJoin = async () => {
    const res = (
      await axios.post("https://api.codedestate.com/waitlist/add", {
        Email: form.Email,
        Name: form.Name,
      })
    ).data;
    if (res) {
      setForm({
        Email: null,
        Name: null,
      });
      setJoinString("Joined to waitlist!");
      setJoinFlag(true);
    }

    if (!res) {
      setForm({
        Email: null,
        Name: null,
      });
      setJoinString("You already joined!");
      setJoinFlag(true);
    }
  };

  return (
    <>
      {loaded && (
        <div
          style={{ fontFamily: "General Sans" }}
          className="w-full overflow-hidden  bg-white flex flex-col items-center"
        >
          <Topbar isBlurred={isAnyModalOpen} />
          <Modal
            center
            open={join}
            // showCloseIcon={false}
            onClose={() => setJoin(false)}
            classNames={{
              modal:
                "sm:w-[400px]  max-w-[100vw] h-max rounded-[8px] border-[1px] border-[#E3E3E3] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]",
            }}
          >
            <div className="flex flex-col items-center space-y-5 mt-6">
              <div className="sm:text-[28px] text-[20px] font-bold leading-none text-center">
                Join the waitling-list of <br />
                <span className="w-max relative">
                  Coded Estate
                  <CodedEstate />
                </span>
              </div>
              <div className="my-6 text-center sm:text-[18px] text-[14px]">
                Sign up to join the waiting list of 100,000 super users to get
                first alpha on Coded Estate’s first product launch.
              </div>

              {joinflag === null && (
                <>
                  <div
                    onClick={() => setJoinFlag(false)}
                    className="select-none px-[14px] py-[8px] rounded-[12px] bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] text-white text-center cursor-pointer shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] hover:shadow-[-1px_6px_10px_0_rgba(93,0,207,0.5)] hover:translate-y-[-3px]"
                  >
                    Join Waitlist
                  </div>
                  <div className="ml-[-90%]">
                    <Lottie loop={false} animationData={joinJson} />
                  </div>
                </>
              )}

              {joinflag === false && (
                <>
                  <div className="bg-white px-[12px] flex items-center gap-1 sm:w-[70%] w-[100%] py-[8px] border-[2px] border-[#E3E3E3] rounded-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                    <Flag />

                    <input
                      className="outline-none w-full"
                      placeholder="Full name"
                      value={form.Name}
                      onChange={(e) =>
                        setForm({ ...form, Name: e.target.value })
                      }
                    />
                  </div>
                  <div className="bg-white px-[12px] flex items-center gap-1 sm:w-[70%] w-[100%] py-[8px] border-[2px] border-[#E3E3E3] rounded-[12px] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                    <Flag2 />
                    <input
                      className="outline-none w-full"
                      placeholder="Email"
                      value={form.Email}
                      onChange={(e) =>
                        setForm({ ...form, Email: e.target.value })
                      }
                    />
                  </div>

                  <div
                    onClick={() => handleJoin()}
                    className="sm:w-[70%] w-[100%] select-none px-[14px] py-[8px] rounded-[12px] bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] text-white text-center cursor-pointer shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] hover:shadow-[-1px_6px_10px_0_rgba(93,0,207,0.5)] hover:translate-y-[-3px]"
                  >
                    Join
                  </div>
                </>
              )}

              {joinflag === true && (
                <>
                  <Lottie
                    animationData={success}
                    loop={false}
                    className="m-auto w-[160px]"
                    onComplete={() => setJoin(false)}
                  />
                  <div className="w-full text-center text-[20px]">
                    {joinString}
                  </div>
                </>
              )}
            </div>
          </Modal>

          <div className="except  select-none fixed z-[100] sm:max-w-[1200px] w-[90vw] flex sm:flex-row flex-col justify-between sm:items-center mt-4 shadow-[1px_2px_20px_0px_rgba(0,0,0,0.08)] rounded-xl bg-white  lg:h-14 p-4">
            {/* <Fade direction="bottom-right"> */}
            <svg
              onScroll={() => setPosition(0)}
              width="118"
              height="38"
              viewBox="0 0 118 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clip-path="url(#clip0_1395_81513)">
                <path
                  d="M64.5417 15.2836C62.4848 15.2836 60.9277 13.6281 60.9277 11.4484C60.9277 9.30642 62.4848 7.66967 64.5417 7.66967C65.6892 7.66967 66.9489 8.32011 67.8026 9.36289L69.7099 7.09189C68.4124 5.75076 66.4113 4.89612 64.4853 4.89612C60.5402 4.89612 57.5574 7.72614 57.5574 11.486C57.5574 15.3024 60.4651 18.1862 64.3759 18.1862C66.2856 18.1862 68.3402 17.2375 69.7315 15.8023L67.8055 13.7543C66.896 14.687 65.6357 15.2836 64.5417 15.2836Z"
                  fill="#323260"
                />
                <path
                  d="M75.8204 18.1489C79.0813 18.1489 81.2697 16.101 81.2697 13.0102C81.2697 9.91952 79.0842 7.89038 75.8204 7.89038C72.541 7.89038 70.3555 9.91952 70.3555 13.0102C70.3555 16.1036 72.541 18.1489 75.8204 18.1489ZM75.8204 10.4436C77.1366 10.4436 78.0438 11.5052 78.0438 13.0505C78.0438 14.6147 77.1366 15.6575 75.8204 15.6575C74.4856 15.6575 73.5791 14.6147 73.5791 13.0505C73.5791 11.5052 74.4885 10.4436 75.8204 10.4436Z"
                  fill="#323260"
                />
                <path
                  d="M87.0166 18.1663C88.2955 18.1663 89.3144 17.6449 90.0185 16.715V18.0373H93.2228V4.22583H90.0185V9.32689C89.3144 8.39694 88.2583 7.87558 86.9421 7.87558C84.1811 7.87558 82.3464 9.90466 82.3464 12.9766C82.3488 16.0834 84.2003 18.1663 87.0166 18.1663ZM87.7951 10.4422C89.1299 10.4422 90.0185 11.5038 90.0185 13.0491C90.0185 14.5945 89.1299 15.6749 87.7951 15.6749C86.4603 15.6749 85.5724 14.5945 85.5537 13.0491C85.5724 11.5038 86.4603 10.4422 87.7951 10.4422Z"
                  fill="#323260"
                />
                <path
                  d="M100.32 18.1485C102.155 18.1485 103.656 17.4954 104.675 16.3801L102.99 14.7245C102.324 15.3937 101.471 15.7485 100.601 15.7485C99.4159 15.7485 98.5629 15.0793 98.2469 13.886H105.269C105.491 10.2202 103.75 7.8927 100.229 7.8927C97.1344 7.8927 95.0239 9.94067 95.0239 13.0502C95.021 16.1033 97.0593 18.1485 100.32 18.1485ZM100.264 10.1261C101.412 10.1261 102.19 10.927 102.19 12.1552H98.1882C98.3918 10.9458 99.1512 10.1261 100.264 10.1261Z"
                  fill="#323260"
                />
                <path
                  d="M113.986 4.22583V9.32689C113.283 8.39694 112.226 7.87558 110.91 7.87558C108.15 7.87558 106.314 9.90466 106.314 12.9766C106.314 16.0861 108.168 18.169 110.983 18.169C112.261 18.169 113.281 17.6476 113.984 16.7177V18.04H117.189V4.22853H113.986V4.22583ZM111.764 15.6722C110.429 15.6722 109.541 14.5918 109.522 13.0464C109.541 11.5011 110.429 10.4395 111.764 10.4395C113.099 10.4395 113.986 11.5011 113.986 13.0464C113.986 14.5918 113.099 15.6722 111.764 15.6722Z"
                  fill="#323260"
                />
                <path
                  d="M60.9042 27.713H67.4444V26.2805H60.9042V21.9992H68.223V20.5667H59.4221V33.5961H68.4639V32.1797H60.9042V27.713Z"
                  fill="#323260"
                />
                <path
                  d="M71.9757 26.2805C71.9757 25.3694 72.8101 24.977 73.9017 24.977C74.8083 24.977 75.7899 25.2941 76.5498 25.7779L77.1061 24.6249C76.2903 24.0659 75.1615 23.7326 73.9925 23.7326C72.2137 23.7326 70.6031 24.5147 70.6031 26.3933C70.5845 29.8738 76.0494 28.6643 75.9936 31.0294C75.9744 31.9969 75.0492 32.4269 73.8988 32.4269C72.7514 32.4269 71.491 31.962 70.6566 31.1799L70.1003 32.2792C71.0261 33.1714 72.454 33.6552 73.8424 33.6552C75.7125 33.6552 77.4192 32.8005 77.4192 30.8627C77.4215 27.342 71.9757 28.4574 71.9757 26.2805Z"
                  fill="#323260"
                />
                <path
                  d="M82.9355 32.2552C82.1006 32.2552 81.638 31.8091 81.638 30.6158V25.2729H84.733V24.0823L81.638 24.1012V21.513H80.2124V24.1012H78.8025V25.2756H80.2124V30.8792C80.2124 32.8143 81.2691 33.6716 82.6946 33.6716C83.4732 33.6528 84.2139 33.3921 84.8988 32.9271L84.4921 31.7527C83.9544 32.0886 83.4354 32.2552 82.9355 32.2552Z"
                  fill="#323260"
                />
                <path
                  d="M90.7473 23.7303C89.0802 23.7303 88.0241 24.2141 86.7638 25.0526L87.3765 26.1142C88.3959 25.4073 89.3961 24.9962 90.4685 24.9962C92.1915 24.9962 93.0823 25.8508 93.0823 27.286V27.8638H89.8774C87.5795 27.8826 86.229 28.9603 86.229 30.675C86.229 32.3682 87.5266 33.6717 89.5457 33.6717C91.1028 33.6717 92.3439 33.1503 93.1225 32.0886V33.5964H94.5324L94.5132 27.1193C94.4922 25.015 93.1574 23.7303 90.7473 23.7303ZM93.1009 30.2074C92.7291 31.5673 91.4694 32.4031 89.8215 32.4031C88.4494 32.4031 87.5795 31.6963 87.5795 30.6159C87.5795 29.5355 88.4331 29.0329 90.0624 29.0329H93.1009V30.2074Z"
                  fill="#323260"
                />
                <path
                  d="M100.484 32.2552C99.6487 32.2552 99.1861 31.8091 99.1861 30.6158V25.2729H102.281V24.0823L99.1861 24.1012V21.513H97.7605V24.1012H96.3506V25.2756H97.7605V30.8792C97.7605 32.8143 98.8172 33.6716 100.243 33.6716C101.021 33.6528 101.762 33.3921 102.447 32.9271L102.04 31.7527C101.503 32.0886 100.983 32.2552 100.484 32.2552Z"
                  fill="#323260"
                />
                <path
                  d="M108.186 23.749C105.351 23.749 103.35 25.7781 103.35 28.7022C103.35 31.6236 105.332 33.6527 108.206 33.6527C109.837 33.6527 111.207 33.0587 112.135 32.0159L111.338 31.1613C110.578 31.9622 109.521 32.3895 108.318 32.3895C106.429 32.3895 105.038 31.1801 104.779 29.2612H112.748C112.894 25.9259 111.338 23.7301 108.186 23.749ZM104.779 28.0679C105.001 26.2054 106.335 24.996 108.189 24.996C110.099 24.996 111.356 26.1866 111.45 28.0679H104.779Z"
                  fill="#323260"
                />
                <path
                  d="M18.897 35.7975L25.5417 1.52553C25.7343 0.536502 26.5448 -0.135392 27.3527 0.0231752C28.0454 0.157554 28.5109 0.85901 28.5109 1.67872C28.5109 1.81579 28.4976 1.95823 28.4708 2.10067L21.8261 36.3727C21.6335 37.3617 20.823 38.0336 20.0152 37.875C19.3224 37.7407 18.8569 37.0392 18.8569 36.2195C18.8569 36.0824 18.8703 35.94 18.897 35.7975Z"
                  fill="url(#paint0_linear_1395_81513)"
                />
                <path
                  d="M21.9475 6.984C21.8004 7.74727 21.1343 8.29821 20.3612 8.29821H13.3662L13.3368 8.3009L4.11877 18.9464L13.3528 29.6107L13.3662 29.5973H15.6025C16.619 29.5973 17.384 30.5299 17.1887 31.5324C17.0416 32.2956 16.3756 32.8466 15.6025 32.8466H13.3662C12.4995 32.8466 11.6568 32.5026 11.055 31.9005L1.67652 21.075C1.12013 20.4945 0.8125 19.7419 0.8125 18.9464C0.8125 18.1509 1.11745 17.3984 1.67652 16.8206L10.9748 6.081L11.0577 5.99232C11.6622 5.39297 12.5048 5.04895 13.3688 5.04895H20.3639C21.3778 5.04895 22.1428 5.98156 21.9475 6.984Z"
                  fill="url(#paint1_linear_1395_81513)"
                />
                <path
                  d="M36.3112 5.99525L39.3313 9.48102H43.7932C44.3924 9.48102 44.8792 9.97016 44.8792 10.5722V11.8568C44.8792 12.4589 44.3924 12.948 43.7932 12.948H42.3327L45.6897 16.8235C46.2461 17.404 46.5537 18.1565 46.5537 18.9493C46.5537 19.7449 46.2488 20.4974 45.6897 21.0752L36.3915 31.8121L36.3086 31.9008C35.704 32.5028 34.8614 32.8468 33.9947 32.8468H27.0023C25.9858 32.8468 25.2208 31.9142 25.4134 30.9118C25.5605 30.1485 26.2266 29.5975 27.0023 29.5975L34.0268 29.5948L43.2448 18.9493L34.0135 8.28507L33.9974 8.29846H31.7611C30.7446 8.29846 29.9796 7.36588 30.1748 6.36344C30.3219 5.60015 30.9881 5.04919 31.7611 5.04919H33.9974C34.8641 5.04919 35.7067 5.3959 36.3112 5.99525Z"
                  fill="url(#paint2_linear_1395_81513)"
                />
                <path
                  d="M33.591 15.7939L35.8755 18.4304C36.0118 18.5728 36.0867 18.7556 36.0867 18.9491C36.0867 19.1426 36.0118 19.3253 35.8755 19.4678L33.6097 22.0828L33.591 22.1043C33.4439 22.2495 33.2379 22.3355 33.0266 22.3355H31.4644C31.0899 22.3355 30.7876 22.0317 30.7876 21.6555V16.2427C30.7876 15.8665 31.0899 15.5627 31.4644 15.5627H33.0266C33.2379 15.5627 33.4439 15.6461 33.591 15.7939Z"
                  fill="url(#paint3_linear_1395_81513)"
                />
                <path
                  d="M14.9602 22.0876L12.1863 20.8459C12.0712 20.7949 11.9963 20.6793 11.9963 20.553V17.3414C11.9963 17.215 12.0712 17.0995 12.1863 17.0484L14.9602 15.8067C15.1368 15.7288 15.3347 15.7288 15.5113 15.8067L18.2852 17.0484C18.4002 17.0995 18.4752 17.215 18.4752 17.3414V20.553C18.4752 20.6793 18.4002 20.7949 18.2852 20.8459L15.5113 22.0876C15.3347 22.1682 15.1341 22.1682 14.9602 22.0876Z"
                  fill="url(#paint4_linear_1395_81513)"
                />
              </g>
              <defs>
                <linearGradient
                  id="paint0_linear_1395_81513"
                  x1="-9.45163"
                  y1="38.6873"
                  x2="49.6877"
                  y2="3.78787"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="2.29095e-07" stop-color="#6317F7" />
                  <stop offset="1" stop-color="#18FFFF" />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_1395_81513"
                  x1="-11.9067"
                  y1="34.53"
                  x2="47.2327"
                  y2="-0.36951"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="2.29095e-07" stop-color="#6317F7" />
                  <stop offset="1" stop-color="#18FFFF" />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_1395_81513"
                  x1="-7.00086"
                  y1="42.845"
                  x2="52.1385"
                  y2="7.94554"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="2.29095e-07" stop-color="#6317F7" />
                  <stop offset="1" stop-color="#18FFFF" />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_1395_81513"
                  x1="-7.21988"
                  y1="42.4687"
                  x2="51.9195"
                  y2="7.56926"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="2.29095e-07" stop-color="#6317F7" />
                  <stop offset="1" stop-color="#18FFFF" />
                </linearGradient>
                <linearGradient
                  id="paint4_linear_1395_81513"
                  x1="-11.6507"
                  y1="34.9636"
                  x2="47.4886"
                  y2="0.0641321"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="2.29095e-07" stop-color="#6317F7" />
                  <stop offset="1" stop-color="#18FFFF" />
                </linearGradient>
                <clipPath id="clip0_1395_81513">
                  <rect
                    width="116.375"
                    height="38"
                    fill="white"
                    transform="translate(0.8125)"
                  />
                </clipPath>
              </defs>
            </svg>
            {/* </Fade> */}
            <div
              className={
                menu
                  ? "except h-0 overflow-hidden"
                  : "except sm:mt-0 mt-6 flex sm:flex-row flex-col sm:items-center gap-3 sm:bg-[#fafafa]"
              }
            >
              <div
                className={
                  position === 0
                    ? "bg-[#202020] p-2 h-full rounded-xl text-white"
                    : "text-[#888888] p-2 h-full rounded-xl cursor-pointer"
                }
                onClick={() => {
                  window.scrollTo(0, 0);
                }}
              >
                Home
              </div>
              <div
                className={
                  position === 1
                    ? "bg-[#202020] p-2 h-full rounded-xl text-white hidden sm:block"
                    : "text-[#888888] p-2 h-full rounded-xl cursor-pointer hidden sm:block"
                }
                onClick={() => {
                  const { top } = document
                    .getElementById("own")
                    .getBoundingClientRect();
                  window.scrollTo(0, window.scrollY + top - 100);
                }}
              >
                Rent
              </div>
              <div
                className={
                  position === 2
                    ? "bg-[#202020] p-2 h-full rounded-xl text-white hidden sm:block"
                    : "text-[#888888] p-2 h-full rounded-xl cursor-pointer hidden sm:block"
                }
                onClick={() => {
                  const { top } = document
                    .getElementById("sell")
                    .getBoundingClientRect();
                  window.scrollTo(0, window.scrollY + top - 100);
                }}
              >
                Sell
              </div>
              <div
                className={
                  position === 3
                    ? "bg-[#202020] p-2 h-full rounded-xl text-white hidden sm:block"
                    : "text-[#888888] p-2 h-full rounded-xl cursor-pointer hidden sm:block"
                }
                onClick={() => {
                  const { top } = document
                    .getElementById("trade")
                    .getBoundingClientRect();
                  window.scrollTo(0, window.scrollY + top - 100);
                }}
              >
                Trade
              </div>
              <div
                className={`p-1 sm:p-3 h-full ${
                  position === 4
                    ? "bg-[#202020] rounded-lg text-white"
                    : "text-[#888888] rounded-lg cursor-pointer"
                } text-xs sm:text-sm`}
                onClick={() => {
                  const { top } = document
                    .getElementById("howItWorks")
                    .getBoundingClientRect();
                  window.scrollTo(0, window.scrollY + top - 100);
                }}
              >
                How it Works
              </div>
            </div>
            <div
              className={
                menu
                  ? "except h-0 overflow-hidden"
                  : "except sm:mt-0 mt-6 flex items-center gap-3 sm:ml-0 ml-2"
              }
            >
              <a href="https://discord.gg/fWfgQA8K6F" target="blank">
                <svg
                  className="cursor-pointer"
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.41985 9.229C8.79285 9.229 8.29785 9.779 8.29785 10.45C8.29785 11.121 8.80385 11.671 9.41985 11.671C10.0469 11.671 10.5419 11.121 10.5419 10.45C10.5529 9.779 10.0469 9.229 9.41985 9.229ZM13.4349 9.229C12.8079 9.229 12.3129 9.779 12.3129 10.45C12.3129 11.121 12.8189 11.671 13.4349 11.671C14.0619 11.671 14.5569 11.121 14.5569 10.45C14.5569 9.779 14.0619 9.229 13.4349 9.229Z"
                    fill="#202020"
                  />
                  <path
                    d="M18.7804 0H4.0404C2.7974 0 1.7854 1.012 1.7854 2.266V17.138C1.7854 18.392 2.7974 19.404 4.0404 19.404H16.5144L15.9314 17.369L17.3394 18.678L18.6704 19.91L21.0354 22V2.266C21.0354 1.012 20.0234 0 18.7804 0ZM14.5344 14.366C14.5344 14.366 14.1384 13.893 13.8084 13.475C15.2494 13.068 15.7994 12.166 15.7994 12.166C15.3484 12.463 14.9194 12.672 14.5344 12.815C13.9844 13.046 13.4564 13.2 12.9394 13.288C11.8834 13.486 10.9154 13.431 10.0904 13.277C9.4634 13.156 8.9244 12.98 8.4734 12.804C8.2204 12.705 7.9454 12.584 7.6704 12.43C7.6374 12.408 7.6044 12.397 7.5714 12.375C7.5494 12.364 7.5384 12.353 7.5274 12.342C7.3294 12.232 7.2194 12.155 7.2194 12.155C7.2194 12.155 7.7474 13.035 9.1444 13.453C8.8144 13.871 8.4074 14.366 8.4074 14.366C5.9764 14.289 5.0524 12.694 5.0524 12.694C5.0524 9.152 6.6364 6.281 6.6364 6.281C8.2204 5.093 9.7274 5.126 9.7274 5.126L9.8374 5.258C7.8574 5.83 6.9444 6.699 6.9444 6.699C6.9444 6.699 7.1864 6.567 7.5934 6.38C8.7704 5.863 9.7054 5.72 10.0904 5.687C10.1564 5.676 10.2114 5.665 10.2774 5.665C10.9484 5.577 11.7074 5.555 12.4994 5.643C13.5444 5.764 14.6664 6.072 15.8104 6.699C15.8104 6.699 14.9414 5.874 13.0714 5.302L13.2254 5.126C13.2254 5.126 14.7324 5.093 16.3164 6.281C16.3164 6.281 17.9004 9.152 17.9004 12.694C17.9004 12.694 16.9654 14.289 14.5344 14.366Z"
                    fill="#202020"
                  />
                </svg>
              </a>
              <a href="https://medium.com/@codedestate" target="blank">
                <svg
                  className="cursor-pointer"
                  width="23"
                  height="22"
                  viewBox="0 0 23 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_1395_81525)">
                    <g clip-path="url(#clip1_1395_81525)">
                      <path
                        d="M6.67197 4.81604C10.0989 4.81604 12.8767 7.61322 12.8767 11.0634C12.8767 14.5136 10.0986 17.3105 6.67197 17.3105C3.24547 17.3105 0.467285 14.5136 0.467285 11.0634C0.467285 7.61331 3.24521 4.81604 6.67197 4.81604ZM16.5806 5.18196C18.294 5.18196 19.683 7.81491 19.683 11.0634H19.6833C19.6833 14.311 18.2942 16.9447 16.5809 16.9447C14.8676 16.9447 13.4785 14.311 13.4785 11.0634C13.4785 7.81577 14.8672 5.18196 16.5807 5.18196H16.5806ZM21.3761 5.79461C21.9786 5.79461 22.4673 8.15351 22.4673 11.0634C22.4673 13.9724 21.9788 16.3323 21.3761 16.3323C20.7735 16.3323 20.2852 13.9731 20.2852 11.0634C20.2852 8.15368 20.7737 5.79461 21.3761 5.79461Z"
                        fill="black"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_1395_81525">
                      <rect
                        width="22"
                        height="22"
                        fill="white"
                        transform="translate(0.955566)"
                      />
                    </clipPath>
                    <clipPath id="clip1_1395_81525">
                      <rect
                        width="22"
                        height="12.5488"
                        fill="white"
                        transform="translate(0.466797 4.78882)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </a>
              <a
                href="https://x.com/codedestate?s=21&t=5OdxYhHLF31Z8VwzP3lI0g"
                target="blank"
              >
                <svg
                  className="cursor-pointer"
                  width="25"
                  height="22"
                  viewBox="0 0 25 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.176 3H20.9362L14.9061 9.77743L22 19H16.4456L12.0951 13.4065L7.11724 19H4.35543L10.8052 11.7508L4 3H9.69542L13.6278 8.11263L18.176 3ZM17.2074 17.3754H18.7367L8.86443 4.53927H7.22319L17.2074 17.3754Z"
                    fill="#202020"
                  />
                </svg>
              </a>
            </div>
            <svg
              onClick={(e) => {
                e.stopPropagation();
                setMenu(!menu);
              }}
              className="sm:hidden absolute top-5 right-4"
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="0.5"
                width="31"
                height="31"
                rx="7.5"
                fill="#FAFAFA"
              />
              <rect
                x="0.5"
                y="0.5"
                width="31"
                height="31"
                rx="7.5"
                stroke="#F6F6F6"
              />
              <path
                d="M9.49609 16H22.5012"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.49609 20.0017H22.5012"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M9.49609 11.9983H22.5012"
                stroke="#323232"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div className="min-h-screen">
            <div
              id="home"
              className="text-[16px]  sm:text-[28px] md:text-[36px] lg:text-[56px] w-[90vw] sm:w-full font-semibold leading-none mt-[2vh] sm:mt-[24vh] lg:mt-[16vh] md:mt-[24vh] text-center flex flex-col items-center justify-center"
            >
              <div className="text-[30px] sm:text-[60px] ml-8 sm:ml-0  flex justify-center text-center flex-col items-center gap-4 ">
                <div>
                  <div className="mt-10 md:mt-10 text-md pt-16 sm:pt-0 pt-0  ">
                    Unlock Real Estate{" "}
                    <span className="hidden sm:hidden lg:inline text-md">
                      &
                    </span>
                  </div>
                  <span className="inline sm:inline lg:hidden text-md  ">
                    &
                  </span>
                  RWA on the
                  <span className="w-max  relative text-md  ">
                    {" "}
                    Blockchain
                    <svg
                      className="w-full absolute sm:top-[50px] top-[24px] h-[16px] left-0 widthAnimation"
                      width="352"
                      height="32"
                      viewBox="0 0 352 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="352"
                        height="32"
                        fill="url(#paint0_linear_963_79931)"
                        fill-opacity="0.12"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_963_79931"
                          x1="101.689"
                          y1="16"
                          x2="107.865"
                          y2="-22.8301"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="0" stop-color="#6317F7" />
                          <stop offset="1" stop-color="#18FFFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                </div>
                <div className=" flex jusitfy-center items-center text-center  sm:inline text-gray-600 text-sm text-md ">
                  Powered by AI , Smart Contracts , NFTs & Zero-Knowledge Proofs
                </div>
              </div>
            </div>

          
       

            <div className="sm:flex  items-center gap-3 mt-[10vh] sm:[4vh] md:[10vh] lg:[10vh]  hidden justify-center ">
            <a href="https://app.codedestate.com/perps/market">
                <div className="cursor-pointer shadow-lg hover:bg-gradient-to-tr group via-[#5b1dee90] from-[#5b1dee] to-[#5b1dee] flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[160px] h-[120px] relative">
                  <LiveSvg />
                  <svg
                    className="group-hover:hidden"
                    width="29"
                    height="28"
                    viewBox="0 0 29 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                  <rect x="0.5" width="28" height="28" rx="6" fill="#5B1DEE" />
                  <g filter="url(#filter0_d_1313_64854)">
                    <path
                      d="M20.0005 16.8322C20.3221 16.5105 20.5027 16.0742 20.5026 15.6193V7.9975H11.8323H10.2123C9.7575 7.9975 9.32134 8.17813 8.99977 8.49971C8.67819 8.82128 8.49756 9.25744 8.49756 9.71221V15.62C8.49756 16.0748 8.67819 16.5109 8.99977 16.8325C9.32134 17.1541 9.7575 17.3347 10.2123 17.3347H18.7878C19.2427 17.3347 19.679 17.1539 20.0005 16.8322Z"
                      fill="white"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.8337 17.3347L16.1672 20.0025L15.8337 17.3347Z"
                      fill="white"
                    />
                    <path
                      d="M15.8337 17.3347L16.1672 20.0025"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M13.1662 17.3347L12.8328 20.0025L13.1662 17.3347Z"
                      fill="white"
                    />
                    <path
                      d="M13.1662 17.3347L12.8328 20.0025"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M11.9277 20.0025H17.0725H11.9277Z"
                      fill="white"
                    />
                    <path
                      d="M11.9277 20.0025H17.0725"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.166 10.0202H15.4999H14.166Z"
                      fill="white"
                    />
                    <path
                      d="M14.166 10.0202H15.4999"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.5 12.0211H16.8339H15.5Z"
                      fill="white"
                    />
                    <path
                      d="M15.5 12.0211H16.8339"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.6401 8.21467L21.9742 9.54838C22.0993 9.67344 22.1696 9.84307 22.1696 10.02C22.1696 10.1968 22.0994 10.3665 21.9743 10.4916L20.6406 11.8257C20.5156 11.9508 20.3459 12.0211 20.1691 12.0211C19.9922 12.0211 19.8225 11.9509 19.6974 11.8258L18.3634 10.4921C18.1029 10.2317 18.1028 9.80939 18.3632 9.5489L19.697 8.2148C19.9574 7.95433 20.3796 7.95427 20.6401 8.21467Z"
                      fill="white"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M14.5 7.9975H15.8339H14.5Z"
                      fill="white"
                    />
                    <path
                      d="M14.5 7.9975H15.8339"
                      stroke="#202020"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_1313_64854"
                      x="7.99756"
                      y="7.4975"
                      width="15.6719"
                      height="14.0051"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1" dy="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1313_64854"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1313_64854"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>

                <div className="text-center font-medium leading-none group-hover:hidden">
               Crypto &   RWA <br /> Trading
                </div>
                <div className="hidden group-hover:block text-white text-[24px] text-center font-bold leading-none">
                  Enter <br />
                  App
                </div>
              </div>
            </a>
            <a href="https://hotels.codedestate.com">
            <div className="sm:flex items-center gap-3 1 hidden justify-center">
                  <div className="flex flex-col items-center justify-center">
                    <div className="relative cursor-pointer shadow-lg hover:bg-gradient-to-tr group via-[#5b1dee90] from-[#5b1dee] to-[#5b1dee] flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[160px] h-[120px] pt-4">
                      <LiveSvg />
                <svg
                  className="group-hover:hidden"
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="0.5" width="28" height="28" rx="6" fill="#5B1DEE" />
                  <g filter="url(#filter0_d_1313_64839)">
                    <path
                      d="M20.9806 11.8631L20.0844 8.725C20.0241 8.51682 19.8981 8.33373 19.7252 8.20306C19.5523 8.07239 19.3417 8.00116 19.125 8H9.875C9.65827 8.00116 9.44773 8.07239 9.27482 8.20306C9.10191 8.33373 8.97591 8.51682 8.91563 8.725L8.01937 11.8631C8.00656 11.9076 8.00004 11.9537 8 12V13C8 13.3881 8.09036 13.7709 8.26393 14.118C8.4375 14.4652 8.68951 14.7671 9 15V19.5C9 19.6326 9.05268 19.7598 9.14645 19.8536C9.24021 19.9473 9.36739 20 9.5 20H19.5C19.6326 20 19.7598 19.9473 19.8536 19.8536C19.9473 19.7598 20 19.6326 20 19.5V15C20.3105 14.7671 20.5625 14.4652 20.7361 14.118C20.9096 13.7709 21 13.3881 21 13V12C21 11.9537 20.9934 11.9076 20.9806 11.8631ZM12 13C11.9999 13.2579 11.9333 13.5115 11.8066 13.7362C11.6799 13.9609 11.4974 14.1491 11.2768 14.2827C11.0561 14.4162 10.8048 14.4907 10.5469 14.4987C10.2891 14.5068 10.0336 14.4483 9.805 14.3287C9.77022 14.3017 9.73196 14.2794 9.69125 14.2625C9.47942 14.1269 9.30509 13.9402 9.1843 13.7196C9.06351 13.499 9.00013 13.2515 9 13V12.5H12V13ZM16 13C16 13.3978 15.842 13.7794 15.5607 14.0607C15.2794 14.342 14.8978 14.5 14.5 14.5C14.1022 14.5 13.7206 14.342 13.4393 14.0607C13.158 13.7794 13 13.3978 13 13V12.5H16V13ZM20 13C19.9998 13.2516 19.9363 13.4991 19.8154 13.7197C19.6945 13.9403 19.5201 14.127 19.3081 14.2625C19.2679 14.2794 19.2301 14.3015 19.1956 14.3281C18.9671 14.4478 18.7115 14.5064 18.4537 14.4985C18.1958 14.4905 17.9444 14.4162 17.7236 14.2826C17.5029 14.1491 17.3203 13.9609 17.1936 13.7362C17.0668 13.5116 17.0001 13.258 17 13V12.5H20V13Z"
                      fill="white"
                    />
                    <path
                      d="M20.7402 11.9318L20.7404 11.9323C20.7467 11.9544 20.75 11.9772 20.75 12.0002V13C20.75 13.3493 20.6687 13.6938 20.5125 14.0062C20.3562 14.3187 20.1294 14.5904 19.85 14.8L19.75 14.875V15V19.5C19.75 19.5663 19.7237 19.6299 19.6768 19.6768C19.6299 19.7237 19.5663 19.75 19.5 19.75H9.5C9.4337 19.75 9.37011 19.7237 9.32322 19.6768C9.27634 19.6299 9.25 19.5663 9.25 19.5V15V14.875L9.15 14.8C8.87056 14.5904 8.64375 14.3187 8.48754 14.0062C8.33133 13.6938 8.25 13.3493 8.25 13V12.0001C8.25003 11.9772 8.25326 11.9544 8.25961 11.9323L8.25976 11.9318L9.15576 8.79454C9.1558 8.7944 9.15584 8.79427 9.15588 8.79413C9.2012 8.63794 9.29579 8.50057 9.42555 8.40251C9.55526 8.30449 9.71315 8.251 9.87571 8.25H19.1243C19.2868 8.251 19.4447 8.30449 19.5745 8.40251C19.7043 8.5006 19.7989 8.63803 19.8442 8.79429C19.8442 8.79438 19.8442 8.79446 19.8442 8.79454L20.7402 11.9318ZM12.25 13.0001V13V12.5V12.25H12H9H8.75V12.5L8.75 13L8.75 13.0001C8.75016 13.2936 8.8241 13.5823 8.96502 13.8396C9.10594 14.097 9.30933 14.3148 9.55646 14.473L9.57504 14.4849L9.59543 14.4934C9.61547 14.5017 9.63431 14.5127 9.65144 14.526L9.66921 14.5399L9.68917 14.5503C9.95585 14.6897 10.254 14.758 10.5548 14.7486C10.8555 14.7392 11.1488 14.6524 11.4063 14.4965C11.6637 14.3407 11.8766 14.1211 12.0244 13.859C12.1722 13.5968 12.2499 13.301 12.25 13.0001ZM13 12.25H12.75V12.5V13C12.75 13.4641 12.9344 13.9092 13.2626 14.2374C13.5908 14.5656 14.0359 14.75 14.5 14.75C14.9641 14.75 15.4092 14.5656 15.7374 14.2374C16.0656 13.9092 16.25 13.4641 16.25 13V12.5V12.25H16H13ZM20.25 13.0002V13V12.5V12.25H20H17H16.75V12.5V13V13.0001C16.7502 13.3011 16.828 13.597 16.9758 13.8591C17.1237 14.1212 17.3367 14.3408 17.5942 14.4965C17.8518 14.6523 18.1451 14.739 18.4459 14.7483C18.7468 14.7576 19.0449 14.6892 19.3116 14.5496L19.331 14.5394L19.3484 14.526C19.3658 14.5126 19.3849 14.5014 19.4052 14.4929L19.4248 14.4846L19.4428 14.4731C19.6901 14.315 19.8936 14.0972 20.0347 13.8398C20.1757 13.5824 20.2498 13.2937 20.25 13.0002Z"
                      stroke="#202020"
                      stroke-width="0.5"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_1313_64839"
                      x="8"
                      y="8"
                      width="14"
                      height="13"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1" dy="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1313_64839"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1313_64839"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>

                <div className="text-center  font-medium leading-none group-hover:hidden">
                  Hotels
                </div>
                <div className="hidden group-hover:block text-white text-[24px] text-center font-bold leading-none">
                  Enter <br />
                  App
                </div>
                </div>
                </div>
         
              </div>
              </a>
              <a href="https://rental.codedestate.com/">
                <div className="sm:flex items-center gap-3 1 hidden justify-center">
                  <div className="flex flex-col items-center justify-center">
                    <div className="relative cursor-pointer shadow-lg hover:bg-gradient-to-tr group via-[#5b1dee90] from-[#5b1dee] to-[#5b1dee] flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[160px] h-[120px] pt-4">
                      <LiveSvg />

                      <svg
                        className="group-hover:hidden mt-1"
                        width="29"
                        height="28"
                        viewBox="0 0 29 28"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          x="0.5"
                          width="28"
                          height="28"
                          rx="6"
                          fill="#5B1DEE"
                        />
                        <g filter="url(#filter0_d_1313_64843)">
                          <rect
                            x="9"
                            y="13"
                            width="11"
                            height="7"
                            fill="white"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M8.49756 13.797L13.7898 9.26069C14.1985 8.91036 14.8016 8.91036 15.2103 9.26069L20.5026 13.797"
                            fill="white"
                          />
                          <path
                            d="M8.49756 13.797L13.7898 9.26069C14.1985 8.91036 14.8016 8.91036 15.2103 9.26069L20.5026 13.797"
                            stroke="#202020"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M19.8357 20.0025V8.99792C19.8357 8.81374 19.6864 8.66444 19.5023 8.66444H17.5014C17.3173 8.66444 17.168 8.81374 17.168 8.99792V10"
                            fill="white"
                          />
                          <path
                            d="M19.8357 20.0025V8.99792C19.8357 8.81374 19.6864 8.66444 19.5023 8.66444H17.5014C17.3173 8.66444 17.168 8.81374 17.168 8.99792V10"
                            stroke="#202020"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12.8628 20.0025V16.3343C12.8628 15.966 13.1614 15.6674 13.5297 15.6674H15.4699C15.8383 15.6674 16.1369 15.966 16.1369 16.3343V20.0025"
                            fill="white"
                          />
                          <path
                            d="M12.8628 20.0025V16.3343C12.8628 15.966 13.1614 15.6674 13.5297 15.6674H15.4699C15.8383 15.6674 16.1369 15.966 16.1369 16.3343V20.0025"
                            stroke="#202020"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M9.35496 13.0621V20.0025V13.0621Z"
                            fill="white"
                          />
                          <path
                            d="M9.35496 13.0621V20.0025"
                            stroke="#202020"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M20.5026 20.0025H8.49756H20.5026Z"
                            fill="white"
                          />
                          <path
                            d="M20.5026 20.0025H8.49756"
                            stroke="#202020"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_1313_64843"
                            x="7.99756"
                            y="8.16444"
                            width="14.0049"
                            height="13.3381"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                          >
                            <feFlood
                              floodOpacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="1" dy="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_1313_64843"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_1313_64843"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>

                      <div className="text-center font-medium leading-none group-hover:hidden">
                          Rental
                      </div>
                      <div className="hidden group-hover:block text-white text-[24px] text-center font-bold leading-none">
                        Enter <br />
                        App
                      </div>
                    </div>
                  </div>
                </div>
              </a>

          
              <div className="cursor-pointer shadow-lg hover:bg-gradient-to-tr group via-[#5b1dee90] from-[#5b1dee] to-[#5b1dee] flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[160px] h-[120px]">
                <svg
                  className=" group-hover:hidden"
                  width="29"
                  height="28"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="0.5" width="28" height="28" rx="6" fill="#5B1DEE" />
                  <g filter="url(#filter0_d_1313_64868)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.4427 12.9982C10.1512 12.9389 9.83508 12.9502 9.50895 13.0589C8.95738 13.243 8.52054 13.7172 8.38381 14.2828C8.10236 15.4453 8.97539 16.483 10.0905 16.483C10.2112 16.483 10.3286 16.4704 10.4427 16.4477V18.5952C10.4427 19.3722 11.0729 20.0025 11.8506 20.0025H19.5945C20.3721 20.0025 21.0024 19.3722 21.0024 18.5946V10.8507C21.0024 10.073 20.3721 9.44277 19.5945 9.44277H17.4469C17.5063 9.15131 17.4949 8.83518 17.3862 8.50905C17.2015 7.95748 16.7273 7.52064 16.1624 7.38391C14.9999 7.10246 13.9621 7.97549 13.9621 9.09062C13.9621 9.21134 13.9748 9.32872 13.9975 9.44277H11.8499C11.0723 9.44277 10.442 10.073 10.442 10.8507V12.9982H10.4427Z"
                      fill="white"
                      stroke="#202020"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.6245 14.4366L15.2783 13.019C15.4061 12.9095 15.5945 12.9095 15.7222 13.019L17.3761 14.4366"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.1677 16.3758V12.9368C17.1677 12.8793 17.121 12.8326 17.0635 12.8326H16.4382C16.3806 12.8326 16.334 12.8793 16.334 12.9368V13.48"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.9883 16.3758V15.2295C14.9883 15.1144 15.0816 15.021 15.1967 15.021H15.803C15.9181 15.021 16.0114 15.1144 16.0114 15.2295V16.3758"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.8923 14.2069V16.3758"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.3761 16.3758H13.6245"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_1313_64868"
                      x="7.58008"
                      y="6.58006"
                      width="15.1724"
                      height="15.1724"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1" dy="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1313_64868"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1313_64868"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>

                <div className="text-center font-medium leading-none group-hover:hidden">
                  Fractionalized <br /> Ownership
                </div>
                <div className="hidden group-hover:block text-white text-[24px] text-center font-bold leading-none">
                  Coming <br />
                  soon
                </div>
              </div>
            </div>
            
            {/* Mobile 2x2 Grid Layout */}
            <div className="sm:hidden grid grid-cols-2 gap-3 mt-[5vh] px-4 justify-items-center max-w-sm mx-auto">
              {/* Card 1: Rental Properties */}
              <a href="https://app.codedestate.com/rent/onboarding">
              <div className="cursor-pointer shadow-lg flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[140px] h-[120px] relative pt-6 overflow-visible">
                  <svg
                    className="mt-1"
                    width="24"
                    height="23"
                    viewBox="0 0 29 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="0.5"
                      width="28"
                      height="28"
                      rx="6"
                      fill="#5B1DEE"
                    />
                    <g filter="url(#filter0_d_1313_64843)">
                      <rect
                        x="9"
                        y="13"
                        width="11"
                        height="7"
                        fill="white"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8.49756 13.797L13.7898 9.26069C14.1985 8.91036 14.8016 8.91036 15.2103 9.26069L20.5026 13.797"
                        fill="white"
                      />
                      <path
                        d="M8.49756 13.797L13.7898 9.26069C14.1985 8.91036 14.8016 8.91036 15.2103 9.26069L20.5026 13.797"
                        stroke="#202020"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.8357 20.0025V8.99792C19.8357 8.81374 19.6864 8.66444 19.5023 8.66444H17.5014C17.3173 8.66444 17.168 8.81374 17.168 8.99792V10"
                        fill="white"
                      />
                      <path
                        d="M19.8357 20.0025V8.99792C19.8357 8.81374 19.6864 8.66444 19.5023 8.66444H17.5014C17.3173 8.66444 17.168 8.81374 17.168 8.99792V10"
                        stroke="#202020"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.8628 20.0025V16.3343C12.8628 15.966 13.1614 15.6674 13.5297 15.6674H15.4699C15.8383 15.6674 16.1369 15.966 16.1369 16.3343V20.0025"
                        fill="white"
                      />
                      <path
                        d="M12.8628 20.0025V16.3343C12.8628 15.966 13.1614 15.6674 13.5297 15.6674H15.4699C15.8383 15.6674 16.1369 15.966 16.1369 16.3343V20.0025"
                        stroke="#202020"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.35496 13.0621V20.0025V13.0621Z"
                        fill="white"
                      />
                      <path
                        d="M9.35496 13.0621V20.0025"
                        stroke="#202020"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.5026 20.0025H8.49756H20.5026Z"
                        fill="white"
                      />
                      <path
                        d="M20.5026 20.0025H8.49756"
                        stroke="#202020"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_1313_64843"
                        x="7.99756"
                        y="8.16444"
                        width="14.0049"
                        height="13.3381"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                      >
                        <feFlood
                          floodOpacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dx="1" dy="1" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_1313_64843"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_1313_64843"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                  <div className="text-center text-sm font-medium leading-none">
                    Rental<br />Properties
                  </div>
                </div>
              </a>

             {/* Card 2: Hotels Booking */}
             <a href="https://hotels.codedestate.com/">
               <div className="cursor-pointer shadow-lg flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[140px] h-[120px] relative pt-6 overflow-visible">
                 <LiveSvg />
                 <svg
                   className="mt-1"
                   width="24"
                   height="23"
                   viewBox="0 0 29 28"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <rect
                     x="0.5"
                     width="28"
                     height="28"
                     rx="6"
                     fill="#5B1DEE"
                   />
                   <g filter="url(#filter0_d_1313_64843)">
                     <rect
                       x="9"
                       y="13"
                       width="11"
                       height="7"
                       fill="white"
                     />
                     <path
                       fillRule="evenodd"
                       clipRule="evenodd"
                       d="M8.49756 13.797L13.7898 9.26069C14.1985 8.91036 14.8016 8.91036 15.2103 9.26069L20.5026 13.797"
                       fill="white"
                     />
                     <path
                       d="M8.49756 13.797L13.7898 9.26069C14.1985 8.91036 14.8016 8.91036 15.2103 9.26069L20.5026 13.797"
                       stroke="#202020"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       fillRule="evenodd"
                       clipRule="evenodd"
                       d="M19.8357 20.0025V8.99792C19.8357 8.81374 19.6864 8.66444 19.5023 8.66444H17.5014C17.3173 8.66444 17.168 8.81374 17.168 8.99792V10"
                       fill="white"
                     />
                     <path
                       d="M19.8357 20.0025V8.99792C19.8357 8.81374 19.6864 8.66444 19.5023 8.66444H17.5014C17.3173 8.66444 17.168 8.81374 17.168 8.99792V10"
                       stroke="#202020"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       fillRule="evenodd"
                       clipRule="evenodd"
                       d="M12.8628 20.0025V16.3343C12.8628 15.966 13.1614 15.6674 13.5297 15.6674H15.4699C15.8383 15.6674 16.1369 15.966 16.1369 16.3343V20.0025"
                       fill="white"
                     />
                     <path
                       d="M12.8628 20.0025V16.3343C12.8628 15.966 13.1614 15.6674 13.5297 15.6674H15.4699C15.8383 15.6674 16.1369 15.966 16.1369 16.3343V20.0025"
                       stroke="#202020"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       fillRule="evenodd"
                       clipRule="evenodd"
                       d="M9.35496 13.0621V20.0025V13.0621Z"
                       fill="white"
                     />
                     <path
                       d="M9.35496 13.0621V20.0025"
                       stroke="#202020"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                     <path
                       fillRule="evenodd"
                       clipRule="evenodd"
                       d="M20.5026 20.0025H8.49756H20.5026Z"
                       fill="white"
                     />
                     <path
                       d="M20.5026 20.0025H8.49756"
                       stroke="#202020"
                       strokeLinecap="round"
                       strokeLinejoin="round"
                     />
                   </g>
                   <defs>
                     <filter
                       id="filter0_d_1313_64843"
                       x="7.99756"
                       y="8.16444"
                       width="14.0049"
                       height="13.3381"
                       filterUnits="userSpaceOnUse"
                       colorInterpolationFilters="sRGB"
                     >
                       <feFlood
                         floodOpacity="0"
                         result="BackgroundImageFix"
                       />
                       <feColorMatrix
                         in="SourceAlpha"
                         type="matrix"
                         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"
                       />
                       <feOffset dx="1" dy="1" />
                       <feComposite in2="hardAlpha" operator="out" />
                       <feColorMatrix
                         type="matrix"
                         values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                       />
                       <feBlend
                         mode="normal"
                         in2="BackgroundImageFix"
                         result="effect1_dropShadow_1313_64843"
                       />
                       <feBlend
                         mode="normal"
                         in="SourceGraphic"
                         in2="effect1_dropShadow_1313_64843"
                         result="shape"
                       />
                     </filter>
                   </defs>
                 </svg>
                 <div className="text-center text-sm font-medium leading-none">
                   Hotels<br />Booking
                 </div>
               </div>
             </a>

             {/* Card 3: RWA & Crypto Trading */}
             <a href="https://app.codedestate.com/perps/market">
               <div className="cursor-pointer shadow-lg flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[140px] h-[120px] relative pt-6 overflow-visible">
                 <LiveSvg />
                 <svg
                   className="mt-1"
                   width="24"
                   height="23"
                   viewBox="0 0 29 28"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg"
                 >
                   <rect x="0.5" width="28" height="28" rx="6" fill="#5B1DEE" />
                   <g filter="url(#filter0_d_1313_64854)">
                     <path
                       d="M20.0005 16.8322C20.3221 16.5105 20.5027 16.0742 20.5026 15.6193V7.9975H11.8323H10.2123C9.7575 7.9975 9.32134 8.17813 8.99977 8.49971C8.67819 8.82128 8.49756 9.25744 8.49756 9.71221V15.62C8.49756 16.0748 8.67819 16.5109 8.99977 16.8325C9.32134 17.1541 9.7575 17.3347 10.2123 17.3347H18.7878C19.2427 17.3347 19.679 17.1539 20.0005 16.8322Z"
                       fill="white"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                     <path
                       fill-rule="evenodd"
                       clip-rule="evenodd"
                       d="M15.8337 17.3347L16.1672 20.0025L15.8337 17.3347Z"
                       fill="white"
                     />
                     <path
                       d="M15.8337 17.3347L16.1672 20.0025"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                     <path
                       fill-rule="evenodd"
                       clip-rule="evenodd"
                       d="M13.1662 17.3347L12.8328 20.0025L13.1662 17.3347Z"
                       fill="white"
                     />
                     <path
                       d="M13.1662 17.3347L12.8328 20.0025"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                     <path
                       fill-rule="evenodd"
                       clip-rule="evenodd"
                       d="M11.9277 20.0025H17.0725H11.9277Z"
                       fill="white"
                     />
                     <path
                       d="M11.9277 20.0025H17.0725"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                     <path
                       fill-rule="evenodd"
                       clip-rule="evenodd"
                       d="M14.166 10.0202H15.4999H14.166Z"
                       fill="white"
                     />
                     <path
                       d="M14.166 10.0202H15.4999"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                     <path
                       fill-rule="evenodd"
                       clip-rule="evenodd"
                       d="M15.5 12.0211H16.8339H15.5Z"
                       fill="white"
                     />
                     <path
                       d="M15.5 12.0211H16.8339"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                     <path
                       fill-rule="evenodd"
                       clip-rule="evenodd"
                       d="M20.6401 8.21467L21.9742 9.54838C22.0993 9.67344 22.1696 9.84307 22.1696 10.02C22.1696 10.1968 22.0994 10.3665 21.9743 10.4916L20.6406 11.8257C20.5156 11.9508 20.3459 12.0211 20.1691 12.0211C19.9922 12.0211 19.8225 11.9509 19.6974 11.8258L18.3634 10.4921C18.1029 10.2317 18.1028 9.80939 18.3632 9.5489L19.697 8.2148C19.9574 7.95433 20.3796 7.95427 20.6401 8.21467Z"
                       fill="white"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                     <path
                       fill-rule="evenodd"
                       clip-rule="evenodd"
                       d="M14.5 7.9975H15.8339H14.5Z"
                       fill="white"
                     />
                     <path
                       d="M14.5 7.9975H15.8339"
                       stroke="#202020"
                       stroke-linecap="round"
                       stroke-linejoin="round"
                     />
                   </g>
                   <defs>
                     <filter
                       id="filter0_d_1313_64854"
                       x="7.99756"
                       y="7.4975"
                       width="15.6719"
                       height="14.0051"
                       filterUnits="userSpaceOnUse"
                       color-interpolation-filters="sRGB"
                     >
                       <feFlood flood-opacity="0" result="BackgroundImageFix" />
                       <feColorMatrix
                         in="SourceAlpha"
                         type="matrix"
                         values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"
                       />
                       <feOffset dx="1" dy="1" />
                       <feComposite in2="hardAlpha" operator="out" />
                       <feColorMatrix
                         type="matrix"
                         values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                       />
                       <feBlend
                         mode="normal"
                         in2="BackgroundImageFix"
                         result="effect1_dropShadow_1313_64854"
                       />
                       <feBlend
                         mode="normal"
                         in="SourceGraphic"
                         in2="effect1_dropShadow_1313_64854"
                         result="shape"
                       />
                     </filter>
                   </defs>
                 </svg>
                 <div className="text-center text-sm font-medium leading-none">
                   RWA & Crypto<br />Trading
                 </div>
               </div>
             </a>

              {/* Card 4: Fractionalized Ownership */}
              <div className="cursor-pointer shadow-lg hover:bg-gradient-to-tr group via-[#5b1dee90] from-[#5b1dee] to-[#5b1dee] flex flex-col space-y-2 items-center justify-center shadow-[2px_2px_6px_0px_rgba(187, 195, 206, 0.60)] border-[2px] rounded-lg w-[140px] h-[120px] pt-6">
                <svg
                  className="group-hover:hidden"
                  width="24"
                  height="23"
                  viewBox="0 0 29 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="0.5" width="28" height="28" rx="6" fill="#5B1DEE" />
                  <g filter="url(#filter0_d_1313_64868)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.4427 12.9982C10.1512 12.9389 9.83508 12.9502 9.50895 13.0589C8.95738 13.243 8.52054 13.7172 8.38381 14.2828C8.10236 15.4453 8.97539 16.483 10.0905 16.483C10.2112 16.483 10.3286 16.4704 10.4427 16.4477V18.5952C10.4427 19.3722 11.0729 20.0025 11.8506 20.0025H19.5945C20.3721 20.0025 21.0024 19.3722 21.0024 18.5946V10.8507C21.0024 10.073 20.3721 9.44277 19.5945 9.44277H17.4469C17.5063 9.15131 17.4949 8.83518 17.3862 8.50905C17.2015 7.95748 16.7273 7.52064 16.1624 7.38391C14.9999 7.10246 13.9621 7.97549 13.9621 9.09062C13.9621 9.21134 13.9748 9.32872 13.9975 9.44277H11.8499C11.0723 9.44277 10.442 10.073 10.442 10.8507V12.9982H10.4427Z"
                      fill="white"
                      stroke="#202020"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.6245 14.4366L15.2783 13.019C15.4061 12.9095 15.5945 12.9095 15.7222 13.019L17.3761 14.4366"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.1677 16.3758V12.9368C17.1677 12.8793 17.121 12.8326 17.0635 12.8326H16.4382C16.3806 12.8326 16.334 12.8793 16.334 12.9368V13.48"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M14.9883 16.3758V15.2295C14.9883 15.1144 15.0816 15.021 15.1967 15.021H15.803C15.9181 15.021 16.0114 15.1144 16.0114 15.2295V16.3758"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.8923 14.2069V16.3758"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M17.3761 16.3758H13.6245"
                      stroke="#323232"
                      stroke-width="0.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_1313_64868"
                      x="7.58008"
                      y="6.58006"
                      width="15.1724"
                      height="15.1724"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1" dy="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1313_64868"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1313_64868"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
                <div className="text-center text-sm font-medium leading-none group-hover:hidden">
                  Fractionalized<br />Ownership
                </div>
                <div className="hidden group-hover:block text-white text-lg text-center font-bold leading-none">
                  Coming<br />soon
                </div>
              </div>
            </div>
            {/* </Slide> shadow-[0px_2px_20px_4px_rgba(34,193,230,0.5)] */}

            {/* <Fade> */}
            {/* <div className="sm:hidden w-[100vw] flex items-start gap-3  overflow-auto ">
              <Lottie animationData={allcardjson} loop className="w-full " />
            </div> */}

            {/* <div className="sm:hidden w-full px-6 pt-8 grid grid-cols-1 gap-4 max-w-xs mx-auto">
              <button 
                className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-500 ease-out animate-slideInUp group relative"
                style={{ animationDelay: '0.1s' }}
                onClick={() => handleNavigation('https://app.codedestate.com/perps/markets/')}
              >
                <div className="absolute top-3 left-1/2 transform -translate-x-1/2 flex items-center gap-1">
                  <span className="text-sm font-medium text-gray-700">Live</span>
                  <img src={circle} alt="circle" className="w-4 h-4" />
                </div>
                <div className="flex flex-col items-center mt-8">
                  <div className="mb-3 p-3 bg-gray-100 rounded-xl transition-transform duration-300">
                    <img src={perps} alt="Marketplace" className="w-10 h-10" />
                  </div>
                  <div className="text-lg font-bold text-gray-800">RWA & Crypto</div>
                  <div className="text-base text-gray-600">Trading</div>
                  <div className="text-xs text-gray-500 mt-1">Trade & Invest</div>
                </div>
              </button>
              
              <button 
                className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-500 ease-out animate-slideInUp group relative"
                style={{ animationDelay: '0.3s' }}
                onClick={() => handleNavigation('https://hotels.codedestate.com/')}
              >
                <div className="absolute top-3 left-1/2 transform -translate-x-1/2 flex items-center gap-1">
                  <span className="text-sm font-medium text-gray-700">Live</span>
                  <img src={circle} alt="circle" className="w-4 h-4" />
                </div>
                <div className="flex flex-col items-center mt-8">
                  <div className="mb-3 p-3 bg-gray-100 rounded-xl transition-transform duration-300">
                    <img src={bookinghotel} alt="Booking" className="w-10 h-10" />
                  </div>
                  <div className="text-lg font-bold text-gray-800">Hotel</div>
                  <div className="text-base text-gray-600">Booking</div>
                  <div className="text-xs text-gray-500 mt-1">Book Your Stay</div>
                </div>
              </button>
              
              <button 
                className="bg-white rounded-2xl p-6 shadow-xl hover:shadow-2xl transform hover:scale-105 active:scale-95 transition-all duration-500 ease-out animate-slideInUp group relative"
                style={{ animationDelay: '0.5s' }}
                onClick={() => handleNavigation('https://app.codedestate.com/rent/short')}
              >
                <div className="absolute top-3 left-1/2 transform -translate-x-1/2 flex items-center gap-1">
                  <span className="text-sm font-medium text-gray-700">Live</span>
                  <img src={circle} alt="circle" className="w-4 h-4" />
                </div>
                <div className="flex flex-col items-center mt-8">
                  <div className="mb-3 p-3 bg-gray-100 rounded-xl transition-transform duration-300">
                    <img src={rentalplace} alt="Rental" className="w-10 h-10" />
                  </div>
                  <div className="text-lg font-bold text-gray-800">Rental</div>
                  <div className="text-base text-gray-600">Properties</div>
                  <div className="text-xs text-gray-500 mt-1">Find Your Place</div>
                </div>
              </button>
            </div> */}

            <div className="w-full h-20 flex justify-center items-center my-4 mb-4 sm:mb-0 mt-8 sm:mt-2 md:mt-5 lg:mt-5 xl:mt-20">
              <Lottie
                animationData={scrollDown}
                loop
                className="inline sm:inline lg:inline w-[200px]  flex "
              />
            </div>
          </div>

          {depositAlert && (
            <div
              onClick={() => {
                setDepositAlert(false);
                window.open("https://app.codedestate.com/earn");
              }}
              className="fixed floatingAnimation cursor-pointer top-[170px] pt-4 right-4 w-[60vw] sm:w-[240px] z-[90] bg-gradient-to-b group from-[#4E59FA] to-[#5b1dee] shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)] rounded-lg border-[1px] p-3"
            >
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  setDepositAlert(false);
                }}
                className="absolute top-1 right-1 w-[20px] h-[20px] cursor-pointer"
              >
                <svg
                  className="w-full h-full"
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.92395 8.21999C8.97128 8.26693 8.9979 8.33083 8.9979 8.39749C8.9979 8.46415 8.97128 8.52805 8.92395 8.57499L8.57395 8.92499C8.52701 8.97232 8.46311 8.99894 8.39645 8.99894C8.32979 8.99894 8.26589 8.97232 8.21895 8.92499L5.99895 6.70499L3.77895 8.92499C3.73201 8.97232 3.66811 8.99894 3.60145 8.99894C3.53479 8.99894 3.47089 8.97232 3.42395 8.92499L3.07395 8.57499C3.02662 8.52805 3 8.46415 3 8.39749C3 8.33083 3.02662 8.26693 3.07395 8.21999L5.29395 5.99999L3.07395 3.77999C3.02662 3.73305 3 3.66915 3 3.60249C3 3.53583 3.02662 3.47193 3.07395 3.42499L3.42395 3.07499C3.47089 3.02766 3.53479 3.00104 3.60145 3.00104C3.66811 3.00104 3.73201 3.02766 3.77895 3.07499L5.99895 5.29499L8.21895 3.07499C8.26589 3.02766 8.32979 3.00104 8.39645 3.00104C8.46311 3.00104 8.52701 3.02766 8.57395 3.07499L8.92395 3.42499C8.97128 3.47193 8.9979 3.53583 8.9979 3.60249C8.9979 3.66915 8.97128 3.73305 8.92395 3.77999L6.70395 5.99999L8.92395 8.21999Z"
                    fill="#ffffff"
                  />
                </svg>
              </div>
              <div className="sm:text-[18px] text-[14px] text-white">
                Deposit liquidity & Earn early rewards, points and more with
                Bybit & Coded Estate's pre season campaign.
              </div>
              <img alt="" src={coin} className="w-full" />
            </div>
          )}
          <div className="">
            {bookNowAlert && (
              <SecondFloatingAlert
                onClose={() => setBookNowAlert(false)}
                url="https://hotels.codedestate.com"
              />
            )}
          </div>

          <div className="w-full sm:flex flex-col items-center hidden space-y-6">
            <div id="own" className="text-[30px] font-semibold mt-[20vh]">
              Rent Properties for Short & Long Term
            </div>
            <VideoComponent videoFile={rentVideo} className="sm:max-w-[70vw]" />
            <div className="text-[30px] font-semibold">
              Manage and List your properties for rental
            </div>
            <VideoComponent
              videoFile={manageVideo}
              className="sm:max-w-[70vw]"
            />
            <div className="text-[30px] font-semibold" id="sell">
              List and Buy Properties
            </div>
            <VideoComponent videoFile={listVideo} className="sm:max-w-[70vw]" />
            <div className="text-[30px] font-semibold">
              Invest in Real Estate From $50
            </div>
            <VideoComponent
              videoFile={investVideo}
              className="sm:max-w-[70vw]"
            />
            <div className="text-[30px] font-semibold" id="trade">
              Trade Real Estate from $1
            </div>
            <VideoComponent
              videoFile={TradeVideo}
              className="sm:max-w-[70vw]"
            />
            <div className="text-[30px] font-semibold" id="trade">
              Book Hotels with Unbeatable Prices
            </div>
            <VideoComponent videoFile={BookVideo} className="sm:max-w-[70vw]" />
            <div className="text-[30px] font-semibold" id="trade">
              Automate & Personalized Guidance with Coded AI-Agent
            </div>
            <VideoComponent videoFile={AiVideo} className="sm:max-w-[70vw]" />
          </div>

          <div
            className="text-[36px] sm:text-[24px] font-semibold leading-none mt-[60px] sm:mt-[40px]"
            id="howItWorks"
          >
            <span className="w-max relative mr-2">
              How
              <svg
                className="w-full absolute top-[30px] left-0 widthAnimation"
                width="352"
                height="32"
                viewBox="0 0 352 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="352"
                  height="32"
                  fill="url(#paint0_linear_963_79931)"
                  fill-opacity="0.12"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_963_79931"
                    x1="101.689"
                    y1="16"
                    x2="107.865"
                    y2="-22.8301"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                </defs>
              </svg>
            </span>
            it Works
          </div>

          {/* </Slide> */}
          {/* <Fade> */}
          <div className="text-center w-[90vw] font-medium sm:block hidden my-3">
            Sign in and verify ownership in a few simply clicks and experience
            the first decentralized platform that serves as an all in one hub
            for travelers, investors, future home owners and home owners
          </div>
          <div className="sm:hidden block text-center text-[#5A5A5A] my-2 sm:my-3 text-xs sm:text-sm">
            future home owners and home owners” to <br />
            “current and future home owners.
          </div>

          {/* </Fade> */}
          <div className="w-full h-max sm:flex hidden ">
            <AnimatedCards
              cardsData={[
                {
                  id: 1,
                  title: "01",
                  content: (
                    <div className="sm:rounded-[40px] rounded-2xl relative border-[2px] sm:p-6 p-4 bg-white">
                      <div className="sm:absolute top-[30px] left-[30px] font-semibold sm:text-[24px] text-[18px]">
                        01
                      </div>
                      <div className="w-full sm:grid sm:grid-cols-2 items-center justify-between">
                        <div>
                          <div className="font-semibold sm:text-[24px] text-[18px]">
                            Fractionalized Ownership
                          </div>
                          <div className="text-[#5A5A5A]">
                            Own premium Dubai real estate from as low as $50
                            when you participate in a YieldEstate auction and
                            earn up to 8% Yield* on your fraction of ownership.
                          </div>
                        </div>
                        <img
                          alt=""
                          src={howitworksContent}
                          // className="hover:z-40 transition ease-in-out duration-3 hover:scale-[1.03]"
                        />
                      </div>
                    </div>
                  ),
                },
                {
                  id: 2,
                  title: "02",
                  content: (
                    <div className="sm:rounded-[40px] rounded-2xl relative border-[2px] sm:p-6 p-4 bg-white">
                      <div className="sm:absolute top-[30px] left-[30px] font-semibold sm:text-[24px] text-[18px]">
                        02
                      </div>
                      <div className="w-full sm:grid sm:grid-cols-2 items-center justify-between">
                        <div>
                          <div className="font-semibold sm:text-[24px] text-[18px]">
                            Travel
                          </div>
                          <div className="text-[#5A5A5A]">
                            Unlock travel experiences on the blockchain, find
                            your next home away from home and use cryptocurrency
                            or stable coins to visit unique destinations in the
                            UAE.
                          </div>
                        </div>
                        <img alt="" src={howitworksContent1} />
                      </div>
                    </div>
                  ),
                },
                {
                  id: 3,
                  title: "03",
                  content: (
                    <div className="sm:rounded-[40px] rounded-2xl relative border-[2px] sm:p-6 p-4 bg-white">
                      <div className="sm:absolute top-[30px] left-[30px] font-semibold sm:text-[24px] text-[18px]">
                        03
                      </div>
                      <div className="w-full sm:grid sm:grid-cols-2 items-center justify-between">
                        <div>
                          <div className="font-semibold sm:text-[24px] text-[18px]">
                            Buy & Sell
                          </div>
                          <div className="text-[#5A5A5A]">
                            Verifying & Transferring ownership made easier than
                            ever before leveraging zero-knowledge proofs and
                            smart contracts. Sign in and complete verification
                            to purchase or sell homes in Dubai.
                          </div>
                        </div>
                        <img alt="" src={howitworksContent2} />
                      </div>
                    </div>
                  ),
                },
                {
                  id: 4,
                  title: "04",
                  content: (
                    <div className="sm:rounded-[40px] rounded-2xl relative border-[2px] sm:p-6 p-4 bg-white">
                      <div className="sm:absolute top-[30px] left-[30px] font-semibold sm:text-[24px] text-[18px]">
                        04
                      </div>
                      <div className="w-full sm:grid sm:grid-cols-2 items-center justify-between">
                        <div>
                          <div className="font-semibold sm:text-[24px] text-[18px]">
                            Rental
                          </div>
                          <div className="text-[#5A5A5A]">
                            Extend your travel into home away from home by
                            leveraging on-chain real estate to rent homes more
                            seamless than ever before
                          </div>
                        </div>
                        <img alt="" src={howitworksContent3} />
                      </div>
                    </div>
                  ),
                },
                {
                  id: 5,
                  title: "05",
                  content: (
                    <div className="sm:rounded-[40px] rounded-2xl relative border-[2px] sm:p-6 p-4 bg-white">
                      <div className="sm:absolute top-[30px] left-[30px] font-semibold sm:text-[24px] text-[18px]">
                        05
                      </div>
                      <div className="w-full sm:grid sm:grid-cols-2 items-center justify-between">
                        <div>
                          <div className="font-semibold sm:text-[24px] text-[18px]">
                            RWA & Crypto Trading
                          </div>
                          <div className="text-[#5A5A5A]">
                            Coded Estate RWA Perps, designed for synthetic real
                            estate trading, facilitates cross-margin perp
                            trading across diverse real estate markets. It
                            integrates Real World Asset (RWA) perpetuals with
                            decentralized Perpetual Automated Market Maker (Perp
                            AMM) pools.
                          </div>
                        </div>
                        <img alt="" src={howitworksContent4} />
                      </div>
                    </div>
                  ),
                },
              ]}
            />
          </div>

          <div className="sm:hidden block mt-6 ">
            <AnimatedCards
              cardsData={[
                {
                  id: 1,
                  title: "01",
                  content: (
                    <div className="bg-white w-[90vw] p-3 border-[2px] shadow border-[#E3E3E3] rounded-xl shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                      <div className="font-semibold">01</div>
                      <div className="font-semibold text-[18px] w-[70%] text-center mx-auto">
                        Marketplace Real Estate
                      </div>
                      <img alt="" src={listImg} />
                      {/* <VideoComponent videoFile={listVideo} /> */}
                      <div>
                        Buy and Sell Real Estate on chain within less than 5
                        minutes. Leverage Coded Estate’s smart contracts and
                        zero knowledge proof to bring homes on-chain or purchase
                        premium Dubai Real Estate.
                      </div>
                    </div>
                  ),
                },
                {
                  id: 2,
                  title: "02",
                  content: (
                    <div className="bg-white w-[90vw] p-3 border-[2px] shadow border-[#E3E3E3] rounded-xl shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                      <div className="font-semibold">02</div>
                      <div className="font-semibold text-[18px] w-[70%] text-center mx-auto">
                        Rent Properties for Short & Long Term
                      </div>
                      <img alt="" src={rentImg} />
                      {/* <VideoComponent videoFile={rentVideo} /> */}
                      <div>
                        Travel on and off-chain, paying in native cryptocurrency
                        and stablecoins with no hidden fees.
                      </div>
                    </div>
                  ),
                },
                {
                  id: 3,
                  title: "03",
                  content: (
                    <div className="bg-white w-[90vw] p-3 border-[2px] shadow border-[#E3E3E3] rounded-xl shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                      <div className="font-semibold">03</div>
                      <div className="font-semibold text-[18px] w-[70%] text-center mx-auto">
                        Invest in Real Estate From $50
                      </div>
                      <img alt="" src={investImg} />
                      {/* <VideoComponent videoFile={investVideo} /> */}

                      <div>
                        Own premium Dubai real estate from as low as $50 when
                        you participate in a YieldEstate auction and earn
                        competitive yield* on your fraction of ownership.
                      </div>
                    </div>
                  ),
                },
                {
                  id: 4,
                  title: "04",
                  content: (
                    <div className="bg-white w-[90vw] p-3 border-[2px] shadow border-[#E3E3E3] rounded-xl shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]">
                      <div className="font-semibold">04</div>
                      <div className="font-semibold text-[18px] w-[70%] text-center mx-auto">
                        Leverage Trade Real Estate Indexes
                      </div>
                      <img alt="" src={tradeImg} />
                      {/* <VideoComponent videoFile={leverageVideo} /> */}

                      <div>
                        Coded Estate RWA Perps, designed for synthetic real
                        estate trading, facilitates cross-margin perp trading
                        across diverse real estate markets. It integrates Real
                        World Asset (RWA) perpetuals with decentralized
                        Perpetual Automated Market Maker (Perp AMM) pools.
                      </div>
                    </div>
                  ),
                },
              ]}
            />

            {/* <img
          alt=""
          src={image_c4}
          className="max-w-[90vw] mx-auto hover:z-40 transition ease-in-out duration-3 hover:scale-[1.03]"
        />
        <img
          alt=""
          src={image_c3}
          className="max-w-[90vw] mx-auto hover:z-40 transition ease-in-out duration-3 hover:scale-[1.03]"
        />
        <img
          alt=""
          src={image_c2}
          className="max-w-[90vw] mx-auto hover:z-40 transition ease-in-out duration-3 hover:scale-[1.03]"
        />
        <img
          alt=""
          src={image_c1}
          className="max-w-[90vw] mx-auto hover:z-40 transition ease-in-out duration-3 hover:scale-[1.03]"
        /> */}
          </div>
          <div className="sm:text-[42px] text-[32px] text-center font-semibold leading-none mt-[60px] sm:mb-0 mb-6 sm:mt-[300px]">
            <span className="w-max relative mr-2">
              Key Features
              <svg
                className="w-full absolute sm:top-[30px] top-[20px] left-0 widthAnimation"
                width="352"
                height="32"
                viewBox="0 0 352 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="352"
                  height="32"
                  fill="url(#paint0_linear_963_79931)"
                  fill-opacity="0.12"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_963_79931"
                    x1="101.689"
                    y1="16"
                    x2="107.865"
                    y2="-22.8301"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                </defs>
              </svg>
            </span>
            of CodedEstate
          </div>
          <div className="flex items-center gap-6">
            <div className="sm:flex hidden flex-col items-center">
              {[1, 2, 3, 4, 5].map((i) => (
                <>
                  <div
                    className="text-[24px] cursor-pointer"
                    onClick={() => sliderRef.current.slickGoTo(i - 1)}
                  >
                    {i}
                  </div>
                  <div className="h-[100px] w-[6px] rounded-lg bg-[#F0F0F0] transition duration-[2000ms] ease-in-out">
                    <div
                      className={
                        activeSlideIndex + 1 >= i
                          ? activeSlideIndex + 1 === i
                            ? "h-[10px] w-full bg-[#5b1dee] rounded-lg"
                            : "h-full w-full bg-[#5b1dee] rounded-lg"
                          : "h-0 w-full bg-[#5b1dee] rounded-lg"
                      }
                    ></div>
                  </div>
                </>
              ))}
              <div
                className="text-[24px] cursor-pointer"
                onClick={() => sliderRef.current.slickGoTo(3)}
              ></div>
            </div>

            <div className="sm:max-w-[1000px] w-[90vw] mb-6">
              <Slider
                dots={true}
                infinite={true}
                speed={500}
                slidesToShow={1}
                slidesToScroll={1}
                arrows={false}
                ref={sliderRef}
                beforeChange={(currentSlide, nextSlide) =>
                  setActiveSlideIndex(nextSlide)
                }
              >
                <div className="sm:w-[1000px] w-[80vw] select-none sm:grid sm:grid-cols-2 items-center my-6 text-left space-y-4 gap-4">
                  <div className="sm:grid sm:grid-cols-2 gap-2 sm:space-y-0 space-y-2">
                    <div className="my-auto">
                      <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect width="32" height="32" rx="6" fill="#5B1DEE" />
                        <g filter="url(#filter0_d_984_17317)">
                          <path
                            d="M24.1008 13.3289L22.9805 9.40625C22.9051 9.14603 22.7476 8.91716 22.5315 8.75382C22.3153 8.59049 22.0522 8.50145 21.7812 8.5H10.2188C9.94784 8.50145 9.68467 8.59049 9.46853 8.75382C9.25239 8.91716 9.09488 9.14603 9.01953 9.40625L7.89922 13.3289C7.8832 13.3845 7.87505 13.4421 7.875 13.5V14.75C7.875 15.2351 7.98795 15.7136 8.20491 16.1475C8.42188 16.5815 8.73689 16.9589 9.125 17.25V22.875C9.125 23.0408 9.19085 23.1997 9.30806 23.3169C9.42527 23.4342 9.58424 23.5 9.75 23.5H22.25C22.4158 23.5 22.5747 23.4342 22.6919 23.3169C22.8092 23.1997 22.875 23.0408 22.875 22.875V17.25C23.2631 16.9589 23.5781 16.5815 23.7951 16.1475C24.012 15.7136 24.125 15.2351 24.125 14.75V13.5C24.1249 13.4421 24.1168 13.3845 24.1008 13.3289ZM12.875 14.75C12.8749 15.0724 12.7916 15.3894 12.6333 15.6702C12.4749 15.9511 12.2468 16.1864 11.971 16.3533C11.6952 16.5203 11.3809 16.6133 11.0587 16.6234C10.7364 16.6335 10.417 16.5603 10.1313 16.4109C10.0878 16.3771 10.04 16.3492 9.98906 16.3281C9.72428 16.1586 9.50637 15.9252 9.35538 15.6495C9.20439 15.3737 9.12517 15.0644 9.125 14.75V14.125H12.875V14.75ZM17.875 14.75C17.875 15.2473 17.6775 15.7242 17.3258 16.0758C16.9742 16.4275 16.4973 16.625 16 16.625C15.5027 16.625 15.0258 16.4275 14.6742 16.0758C14.3225 15.7242 14.125 15.2473 14.125 14.75V14.125H17.875V14.75ZM22.875 14.75C22.8747 15.0645 22.7954 15.3738 22.6443 15.6496C22.4931 15.9254 22.2751 16.1587 22.0102 16.3281C21.9599 16.3493 21.9127 16.3769 21.8695 16.4102C21.5838 16.5597 21.2644 16.633 20.9421 16.6231C20.6198 16.6131 20.3055 16.5202 20.0296 16.3533C19.7536 16.1864 19.5254 15.9512 19.367 15.6703C19.2085 15.3894 19.1252 15.0725 19.125 14.75V14.125H22.875V14.75Z"
                            fill="white"
                          />
                          <path
                            d="M23.8604 13.3976L23.8605 13.3981C23.8701 13.4313 23.875 13.4657 23.875 13.5002V14.75C23.875 15.1963 23.7711 15.6365 23.5715 16.0357C23.3719 16.4349 23.0821 16.7822 22.725 17.05L22.625 17.125V17.25V22.875C22.625 22.9745 22.5855 23.0698 22.5152 23.1402C22.4448 23.2105 22.3495 23.25 22.25 23.25H9.75C9.65054 23.25 9.55516 23.2105 9.48484 23.1402C9.41451 23.0698 9.375 22.9745 9.375 22.875V17.25V17.125L9.275 17.05C8.91794 16.7822 8.62813 16.4349 8.42852 16.0357C8.22892 15.6365 8.125 15.1963 8.125 14.75V13.5001C8.12504 13.4656 8.12991 13.4313 8.13946 13.3981L8.13961 13.3976L9.25967 9.47579C9.25971 9.47565 9.25975 9.47551 9.25979 9.47537C9.32018 9.26714 9.44627 9.084 9.61925 8.95328C9.79219 8.82259 10.0027 8.75129 10.2195 8.75H21.7805C21.9973 8.75129 22.2078 8.82259 22.3807 8.95328C22.5538 9.08403 22.6799 9.26721 22.7403 9.4755C22.7403 9.4756 22.7403 9.47569 22.7403 9.47579L23.8604 13.3976ZM13.125 14.7501V14.75V14.125V13.875H12.875H9.125H8.875V14.125L8.875 14.75L8.875 14.7501C8.87519 15.1064 8.96497 15.457 9.1361 15.7695C9.30722 16.0821 9.55418 16.3466 9.85427 16.5387L9.87286 16.5506L9.89324 16.559C9.92347 16.5716 9.95187 16.5881 9.97769 16.6082L9.99546 16.622L10.0154 16.6325C10.3392 16.8018 10.7013 16.8847 11.0665 16.8733C11.4317 16.8619 11.7878 16.7564 12.1005 16.5672C12.4131 16.378 12.6716 16.1113 12.851 15.793C13.0305 15.4747 13.1249 15.1155 13.125 14.7501ZM14.125 13.875H13.875V14.125V14.75C13.875 15.3136 14.0989 15.8541 14.4974 16.2526C14.8959 16.6511 15.4364 16.875 16 16.875C16.5636 16.875 17.1041 16.6511 17.5026 16.2526C17.9011 15.8541 18.125 15.3136 18.125 14.75V14.125V13.875H17.875H14.125ZM23.125 14.7502V14.75V14.125V13.875H22.875H19.125H18.875V14.125V14.75V14.7501C18.8752 15.1156 18.9697 15.4748 19.1492 15.7931C19.3288 16.1114 19.5875 16.378 19.9002 16.5672C20.2129 16.7564 20.5691 16.8617 20.9344 16.873C21.2997 16.8842 21.6617 16.8011 21.9855 16.6316L22.0049 16.6215L22.0223 16.6081C22.0484 16.5879 22.0769 16.5713 22.1072 16.5585L22.1269 16.5502L22.1448 16.5387C22.4451 16.3467 22.6922 16.0823 22.8635 15.7697C23.0348 15.4572 23.1247 15.1066 23.125 14.7502Z"
                            stroke="#202020"
                            stroke-width="0.5"
                          />
                        </g>
                        <defs>
                          <filter
                            id="filter0_d_984_17317"
                            x="7.875"
                            y="8.5"
                            width="17.25"
                            height="16"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="1" dy="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_984_17317"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_984_17317"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>
                      <div className="sm:text-[30px] text-[24px] font-semibold">
                        Marketplace
                      </div>
                      <div className="font-medium text-[#5A5A5A]">
                        Making buying and selling real estate simpler than ever
                        combining traditional property transactions with smart
                        contracts, leveraging the blockchain. Coded Estate
                        removes intermediaries, empowers buyers and removes
                        friction from property ownership
                      </div>
                    </div>
                    <VideoComponent videoFile={marketVideo} />
                  </div>
                </div>
                <div className="sm:w-[1000px] w-[80vw] select-none sm:grid sm:grid-cols-2 items-center my-6 text-left space-y-4 gap-4">
                  <div className="sm:grid sm:grid-cols-2 gap-2 sm:space-y-0 space-y-2">
                    <div className="my-auto">
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 48 48"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_dd_984_34910)">
                          <rect
                            x="8"
                            y="8"
                            width="32"
                            height="32"
                            rx="6"
                            fill="#5B1DEE"
                          />
                          <g filter="url(#filter1_d_984_34910)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M23.5759 15.0967C23.8541 15.0234 24.1464 15.0234 24.4245 15.0967C24.7472 15.1816 25.021 15.3889 25.2394 15.5542L25.3002 15.6001L25.8059 15.9793C25.8695 16.0266 25.934 16.0751 25.9996 16.1245L26.1002 16.2001L32.8335 21.2501C33.2017 21.5262 33.2764 22.0486 33.0002 22.4167C32.7241 22.7849 32.2017 22.8596 31.8335 22.5834L31.5002 22.3334V28.8656C31.5002 29.3048 31.5002 29.6838 31.4747 29.9959C31.4478 30.3254 31.3884 30.6531 31.2277 30.9684C30.988 31.4388 30.6056 31.8212 30.1352 32.0609C29.8199 32.2216 29.4922 32.281 29.1627 32.3079C28.8506 32.3334 28.4716 32.3334 28.0324 32.3334H19.9681C19.5288 32.3334 19.1498 32.3334 18.8377 32.3079C18.5082 32.281 18.1806 32.2216 17.8652 32.0609C17.3948 31.8212 17.0124 31.4388 16.7727 30.9684C16.612 30.6531 16.5526 30.3254 16.5257 29.9959C16.5002 29.6838 16.5002 29.3048 16.5002 28.8655L16.5002 22.3334L16.1669 22.5834C15.7987 22.8596 15.2764 22.7849 15.0002 22.4167C14.7241 22.0486 14.7987 21.5262 15.1669 21.2501L21.9002 16.2001L22.0008 16.1245C22.0664 16.0751 22.1308 16.0266 22.1945 15.9794L22.7002 15.6001L22.7611 15.5542C22.9794 15.3889 23.2533 15.1816 23.5759 15.0967ZM21.5002 25.3334V30.6667H26.5002V25.3334C26.5002 24.8667 26.5002 24.6333 26.4094 24.4551C26.3295 24.2983 26.202 24.1708 26.0452 24.0909C25.8669 24.0001 25.6336 24.0001 25.1669 24.0001H22.8335C22.3668 24.0001 22.1335 24.0001 21.9552 24.0909C21.7984 24.1708 21.6709 24.2983 21.591 24.4551C21.5002 24.6333 21.5002 24.8667 21.5002 25.3334Z"
                              fill="white"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M23.5759 15.0967C23.8541 15.0234 24.1464 15.0234 24.4245 15.0967C24.7472 15.1816 25.021 15.3889 25.2394 15.5542L25.3002 15.6001L25.8059 15.9793C25.8695 16.0266 25.934 16.0751 25.9996 16.1245L26.1002 16.2001L32.8335 21.2501C33.2017 21.5262 33.2764 22.0486 33.0002 22.4167C32.7241 22.7849 32.2017 22.8596 31.8335 22.5834L31.5002 22.3334V28.8656C31.5002 29.3048 31.5002 29.6838 31.4747 29.9959C31.4478 30.3254 31.3884 30.6531 31.2277 30.9684C30.988 31.4388 30.6056 31.8212 30.1352 32.0609C29.8199 32.2216 29.4922 32.281 29.1627 32.3079C28.8506 32.3334 28.4716 32.3334 28.0324 32.3334H19.9681C19.5288 32.3334 19.1498 32.3334 18.8377 32.3079C18.5082 32.281 18.1806 32.2216 17.8652 32.0609C17.3948 31.8212 17.0124 31.4388 16.7727 30.9684C16.612 30.6531 16.5526 30.3254 16.5257 29.9959C16.5002 29.6838 16.5002 29.3048 16.5002 28.8655L16.5002 22.3334L16.1669 22.5834C15.7987 22.8596 15.2764 22.7849 15.0002 22.4167C14.7241 22.0486 14.7987 21.5262 15.1669 21.2501L21.9002 16.2001L22.0008 16.1245C22.0664 16.0751 22.1308 16.0266 22.1945 15.9794L22.7002 15.6001L22.7611 15.5542C22.9794 15.3889 23.2533 15.1816 23.5759 15.0967ZM21.5002 25.3334V30.6667H26.5002V25.3334C26.5002 24.8667 26.5002 24.6333 26.4094 24.4551C26.3295 24.2983 26.202 24.1708 26.0452 24.0909C25.8669 24.0001 25.6336 24.0001 25.1669 24.0001H22.8335C22.3668 24.0001 22.1335 24.0001 21.9552 24.0909C21.7984 24.1708 21.6709 24.2983 21.591 24.4551C21.5002 24.6333 21.5002 24.8667 21.5002 25.3334Z"
                              stroke="black"
                              stroke-width="0.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </g>
                        <defs>
                          <filter
                            id="filter0_dd_984_34910"
                            x="-9.53674e-07"
                            y="-9.53674e-07"
                            width="48"
                            height="48"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="-2" dy="-2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_984_34910"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="2" dy="2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="effect1_dropShadow_984_34910"
                              result="effect2_dropShadow_984_34910"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect2_dropShadow_984_34910"
                              result="shape"
                            />
                          </filter>
                          <filter
                            id="filter1_d_984_34910"
                            x="14.5835"
                            y="14.7917"
                            width="19.8335"
                            height="18.7917"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="1" dy="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_984_34910"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_984_34910"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>

                      <div className="sm:text-[30px] text-[24px] font-semibold">
                        YieldEstate
                      </div>
                      <div className="font-medium text-[#5A5A5A]">
                        Coded Estate offers a new way to invest in real estate.
                        Join us to own a share of premium properties and be part
                        of the future of real estate investing. Choose from
                        different ownership options and explore the next
                        generation of real estate investment opportunities.
                      </div>
                    </div>
                    <VideoComponent videoFile={yieldEstateVideo} />
                  </div>
                </div>
                <div className="sm:w-[1000px] w-[80vw] select-none sm:grid sm:grid-cols-2 items-center my-6 text-left space-y-4 gap-4">
                  <div className="sm:grid sm:grid-cols-2 gap-2 sm:space-y-0 space-y-2">
                    <div className="my-auto">
                      <svg
                        width="48"
                        height="49"
                        viewBox="0 0 48 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_dd_193_59624)">
                          <rect
                            x="8"
                            y="8.5"
                            width="32"
                            height="32"
                            rx="6"
                            fill="#5B1DEE"
                          />
                          <g filter="url(#filter1_d_193_59624)">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M22.3325 22.4167L19.9448 18.2475C19.7971 17.9896 19.7979 17.6725 19.947 17.4154C20.096 17.1583 20.3707 17 20.6679 17H21.5953C21.817 17 22.0296 17.0883 22.1859 17.2454L27.3334 22.4167"
                              fill="white"
                            />
                            <path
                              d="M22.3325 22.4167L19.9448 18.2475C19.7971 17.9896 19.7979 17.6725 19.947 17.4154C20.096 17.1583 20.3707 17 20.6679 17H21.5953C21.817 17 22.0296 17.0883 22.1859 17.2454L27.3334 22.4167L27.7499 23.25H22.7499L22.3325 22.4167Z"
                              stroke="#202020"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M21.341 26.1666L19.0998 30.7733C18.9616 31.0316 18.969 31.3435 19.1196 31.5948C19.2701 31.8461 19.5415 32 19.8345 32H20.8019C21.0245 31.9999 21.2379 31.9108 21.3945 31.7525L27.5365 26.1666"
                              fill="white"
                            />
                            <path
                              d="M21.341 26.1666L19.0998 30.7733C18.9616 31.0316 18.969 31.3435 19.1196 31.5948C19.2701 31.8461 19.5415 32 19.8345 32H20.8019C21.0245 31.9999 21.2379 31.9108 21.3945 31.7525L27.5365 26.1666V25.1248H21.8995L21.341 26.1666Z"
                              stroke="#202020"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M22.1249 26.1667H17.7957C17.0784 26.1668 16.4415 25.7077 16.2146 25.0272L14.8768 21.0136C14.792 20.7595 14.8347 20.4801 14.9913 20.2628C15.1479 20.0455 15.3995 19.9167 15.6673 19.9167H16.8627C17.3143 19.9167 17.7308 20.1603 17.9522 20.5539L19 22.4167H31.2917C32.3272 22.4167 33.1667 23.2562 33.1667 24.2917C33.1667 25.3273 32.3272 26.1667 31.2917 26.1667H26.3568"
                              fill="white"
                            />
                            <path
                              d="M22.1249 26.1667H17.7957C17.0784 26.1668 16.4415 25.7077 16.2146 25.0272L14.8768 21.0136C14.792 20.7595 14.8347 20.4801 14.9913 20.2628C15.1479 20.0455 15.3995 19.9167 15.6673 19.9167H16.8627C17.3143 19.9167 17.7308 20.1603 17.9522 20.5539L19 22.4167H31.2917C32.3272 22.4167 33.1667 23.2562 33.1667 24.2917C33.1667 25.3273 32.3272 26.1667 31.2917 26.1667H26.3568"
                              stroke="#202020"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </g>
                        <defs>
                          <filter
                            id="filter0_dd_193_59624"
                            x="-9.53674e-07"
                            y="0.499999"
                            width="48"
                            height="48"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="-2" dy="-2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_193_59624"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="2" dy="2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="effect1_dropShadow_193_59624"
                              result="effect2_dropShadow_193_59624"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect2_dropShadow_193_59624"
                              result="shape"
                            />
                          </filter>
                          <filter
                            id="filter1_d_193_59624"
                            x="14.084"
                            y="16.25"
                            width="20.8327"
                            height="17.5"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="1" dy="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_193_59624"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_193_59624"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>

                      <div className="sm:text-[30px] text-[24px] font-semibold">
                        Travel
                      </div>
                      <div className="font-medium text-[#5a5a5a]">
                        Enhance your travel experience by utilizing on-chain
                        real estate to make renting homes feel more seamless and
                        convenient, turning your temporary accommodation into a
                        true home away from home.
                      </div>
                    </div>
                    <VideoComponent videoFile={rentalVideo} />
                  </div>
                </div>
                <div className="sm:w-[1000px] w-[80vw] select-none sm:grid sm:grid-cols-2 items-center my-6 text-left space-y-4 gap-4">
                  <div className="sm:grid sm:grid-cols-2 gap-2 sm:space-y-0 space-y-2">
                    <div className="my-auto">
                      <svg
                        width="48"
                        height="49"
                        viewBox="0 0 48 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_dd_193_65461)">
                          <rect
                            x="8"
                            y="8.5"
                            width="32"
                            height="32"
                            rx="6"
                            fill="#5B1DEE"
                          />
                          <g filter="url(#filter1_d_193_65461)">
                            <path
                              d="M30.8756 28.0402C31.2776 27.6381 31.5033 27.0927 31.5031 26.5241V16.9968H20.6653H18.6403C18.0718 16.9968 17.5266 17.2226 17.1246 17.6246C16.7227 18.0266 16.4969 18.5717 16.4969 19.1402V26.525C16.4969 27.0934 16.7227 27.6386 17.1246 28.0406C17.5266 28.4426 18.0718 28.6684 18.6403 28.6684H29.3597C29.9283 28.6684 30.4736 28.4424 30.8756 28.0402Z"
                              fill="white"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M25.6673 28.6685L26.0842 32.0032L25.6673 28.6685Z"
                              fill="white"
                            />
                            <path
                              d="M25.6673 28.6685L26.0842 32.0032"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M22.3327 28.6685L21.9158 32.0032L22.3327 28.6685Z"
                              fill="white"
                            />
                            <path
                              d="M22.3327 28.6685L21.9158 32.0032"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M20.7845 32.0033H27.2155H20.7845Z"
                              fill="white"
                            />
                            <path
                              d="M20.7845 32.0033H27.2155"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M23.5825 19.5252H25.2498H23.5825Z"
                              fill="white"
                            />
                            <path
                              d="M23.5825 19.5252H25.2498"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M25.2499 22.0265H26.9173H25.2499Z"
                              fill="white"
                            />
                            <path
                              d="M25.2499 22.0265H26.9173"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M31.6751 17.2685L33.3427 18.9356C33.4991 19.092 33.587 19.304 33.587 19.5251C33.587 19.7462 33.4992 19.9583 33.3429 20.1146L31.6757 21.7823C31.5194 21.9386 31.3074 22.0265 31.0863 22.0265C30.8652 22.0265 30.6531 21.9387 30.4967 21.7824L28.8292 20.1153C28.5035 19.7897 28.5035 19.2619 28.829 18.9363L30.4961 17.2687C30.8217 16.9431 31.3495 16.943 31.6751 17.2685Z"
                              fill="white"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M24 16.9969H25.6674H24Z"
                              fill="white"
                            />
                            <path
                              d="M24 16.9969H25.6674"
                              stroke="#202020"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </g>
                        </g>
                        <defs>
                          <filter
                            id="filter0_dd_193_65461"
                            x="-9.53674e-07"
                            y="0.499999"
                            width="48"
                            height="48"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="-2" dy="-2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_193_65461"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="2" dy="2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="effect1_dropShadow_193_65461"
                              result="effect2_dropShadow_193_65461"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect2_dropShadow_193_65461"
                              result="shape"
                            />
                          </filter>
                          <filter
                            id="filter1_d_193_65461"
                            x="15.9969"
                            y="16.4968"
                            width="19.0901"
                            height="17.0063"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="1" dy="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_193_65461"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_193_65461"
                              result="shape"
                            />
                          </filter>
                        </defs>
                      </svg>

                      <div className="sm:text-[30px] text-[24px] font-semibold">
                        RWA Perps
                      </div>
                      <div className="font-medium text-[#5a5a5a]">
                        Coded Estate offers a new way to invest in real estate.
                        Join us to own a share of premium properties and be part
                        of the future of real estate investing. Choose from
                        different ownership options and explore the next
                        generation of real estate investment opportunities.
                      </div>
                    </div>
                    <VideoComponent videoFile={rwaPerps} />
                  </div>
                </div>
                <div className="sm:w-[1000px] w-[80vw] select-none sm:grid sm:grid-cols-2 items-center my-6 text-left space-y-4 gap-4">
                  <div className="sm:grid sm:grid-cols-2 gap-2 sm:space-y-0 space-y-2">
                    <div className="my-auto">
                      <svg
                        width="48"
                        height="49"
                        viewBox="0 0 48 49"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g filter="url(#filter0_dd_193_71264)">
                          <rect
                            x="8"
                            y="8.5"
                            width="32"
                            height="32"
                            rx="6"
                            fill="#5B1DEE"
                          />
                          <g clip-path="url(#clip0_193_71264)">
                            <path
                              d="M23.1666 24.8334C23.1666 25.7539 22.4204 26.5001 21.4999 26.5001C20.5794 26.5001 19.8333 25.7539 19.8333 24.8334C19.8333 23.9129 20.5794 23.1667 21.4999 23.1667C22.4204 23.1667 23.1666 23.9129 23.1666 24.8334Z"
                              fill="white"
                            />
                            <path
                              d="M28.1666 24.8334C28.1666 25.7539 27.4204 26.5001 26.4999 26.5001C25.5794 26.5001 24.8333 25.7539 24.8333 24.8334C24.8333 23.9129 25.5794 23.1667 26.4999 23.1667C27.4204 23.1667 28.1666 23.9129 28.1666 24.8334Z"
                              fill="white"
                            />
                            <g filter="url(#filter1_d_193_71264)">
                              <path
                                d="M25.25 15.6667C25.25 16.037 25.0891 16.3696 24.8333 16.5985V18.1667H29C30.3807 18.1667 31.5 19.286 31.5 20.6667V29.0001C31.5 30.3808 30.3807 31.5001 29 31.5001H19C17.6193 31.5001 16.5 30.3808 16.5 29.0001V20.6667C16.5 19.286 17.6193 18.1667 19 18.1667H23.1667V16.5985C22.9109 16.3696 22.75 16.037 22.75 15.6667C22.75 14.9764 23.3097 14.4167 24 14.4167C24.6903 14.4167 25.25 14.9764 25.25 15.6667ZM14 22.3334H15.6667V27.3334H14V22.3334ZM34 22.3334H32.3333V27.3334H34V22.3334ZM21.5 26.0834C22.1904 26.0834 22.75 25.5237 22.75 24.8334C22.75 24.1431 22.1904 23.5834 21.5 23.5834C20.8096 23.5834 20.25 24.1431 20.25 24.8334C20.25 25.5237 20.8096 26.0834 21.5 26.0834ZM27.75 24.8334C27.75 24.1431 27.1903 23.5834 26.5 23.5834C25.8097 23.5834 25.25 24.1431 25.25 24.8334C25.25 25.5237 25.8097 26.0834 26.5 26.0834C27.1903 26.0834 27.75 25.5237 27.75 24.8334Z"
                                fill="white"
                              />
                              <path
                                d="M24.4999 16.2259L24.3333 16.3749V16.5985V18.1667V18.6667H24.8333H29C30.1046 18.6667 31 19.5622 31 20.6667V29.0001C31 30.1047 30.1046 31.0001 29 31.0001H19C17.8954 31.0001 17 30.1047 17 29.0001V20.6667C17 19.5622 17.8954 18.6667 19 18.6667H23.1667H23.6667V18.1667V16.5985V16.3749L23.5001 16.2259C23.3459 16.0878 23.25 15.8888 23.25 15.6667C23.25 15.2525 23.5858 14.9167 24 14.9167C24.4142 14.9167 24.75 15.2525 24.75 15.6667C24.75 15.8888 24.6541 16.0878 24.4999 16.2259ZM14.5 22.8334H15.1667V26.8334H14.5V22.8334ZM32.8333 26.8334V22.8334H33.5V26.8334H32.8333ZM21.5 26.5834C22.4665 26.5834 23.25 25.7999 23.25 24.8334C23.25 23.8669 22.4665 23.0834 21.5 23.0834C20.5335 23.0834 19.75 23.8669 19.75 24.8334C19.75 25.7999 20.5335 26.5834 21.5 26.5834ZM28.25 24.8334C28.25 23.8669 27.4665 23.0834 26.5 23.0834C25.5335 23.0834 24.75 23.8669 24.75 24.8334C24.75 25.7999 25.5335 26.5834 26.5 26.5834C27.4665 26.5834 28.25 25.7999 28.25 24.8334Z"
                                stroke="#202020"
                              />
                            </g>
                          </g>
                        </g>
                        <defs>
                          <filter
                            id="filter0_dd_193_71264"
                            x="-9.53674e-07"
                            y="0.499999"
                            width="48"
                            height="48"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="-2" dy="-2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_193_71264"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="2" dy="2" />
                            <feGaussianBlur stdDeviation="3" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="effect1_dropShadow_193_71264"
                              result="effect2_dropShadow_193_71264"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect2_dropShadow_193_71264"
                              result="shape"
                            />
                          </filter>
                          <filter
                            id="filter1_d_193_71264"
                            x="14"
                            y="14.4167"
                            width="21"
                            height="18.0833"
                            filterUnits="userSpaceOnUse"
                            color-interpolation-filters="sRGB"
                          >
                            <feFlood
                              flood-opacity="0"
                              result="BackgroundImageFix"
                            />
                            <feColorMatrix
                              in="SourceAlpha"
                              type="matrix"
                              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                              result="hardAlpha"
                            />
                            <feOffset dx="1" dy="1" />
                            <feComposite in2="hardAlpha" operator="out" />
                            <feColorMatrix
                              type="matrix"
                              values="0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 0 0.12549 0 0 0 1 0"
                            />
                            <feBlend
                              mode="normal"
                              in2="BackgroundImageFix"
                              result="effect1_dropShadow_193_71264"
                            />
                            <feBlend
                              mode="normal"
                              in="SourceGraphic"
                              in2="effect1_dropShadow_193_71264"
                              result="shape"
                            />
                          </filter>
                          <clipPath id="clip0_193_71264">
                            <rect
                              width="20"
                              height="20"
                              fill="white"
                              transform="translate(14 14)"
                            />
                          </clipPath>
                        </defs>
                      </svg>

                      <div className="sm:text-[30px] text-[24px] font-semibold">
                        Coded Al-Assistant & Web Scraping
                      </div>
                      <div className="font-medium text-[#5A5A5A]">
                        Leveraging advanced web scraping technology, Artificial
                        Intelligence, and strategic third-party partnerships,
                        Coded Estate offers unmatched prices on rental
                        accommodations and global hotel bookings, while
                        providing personalized guidance for real estate
                        investments, sales and RWA market speculation.
                      </div>
                    </div>
                    <VideoComponent videoFile={Ai1} />
                  </div>
                </div>
              </Slider>
            </div>
          </div>

          {/* <Zoom> */}
          <div className="sm:text-[42px]  my-[20px] text-[28px] text-center font-semibold leading-none">
            The Six Key
            <br /> Features of Our <br />
            <span className="w-max relative">
              RWA Real Estate Hub
              <svg
                className="w-full absolute sm:top-[30px] top-[10px] left-0 widthAnimation"
                width="352"
                height="32"
                viewBox="0 0 352 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  width="352"
                  height="32"
                  fill="url(#paint0_linear_963_79931)"
                  fill-opacity="0.12"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_963_79931"
                    x1="101.689"
                    y1="16"
                    x2="107.865"
                    y2="-22.8301"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                </defs>
              </svg>
            </span>
          </div>
          {/* </Zoom> */}
          <div className="relative w-full sm:w-max h-max sm:block hidden mt-[40px] px-4 sm:px-8">
            <img
              alt=""
              src={fiveKey}
              className="max-w-[900px] w-full sm:w-auto"
            />
            <div className="w-full h-full py-6 absolute top-0 left-0 gap-4 flex flex-wrap items-center justify-center">
              <div className="rounded-lg text-center w-[90%] sm:w-[300px] min-h-[250px] gap-3 p-4 border-[1px] bg-white flex flex-col items-center">
                <div className="rounded-md bg-[#5b1dee] p-2">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_d_1568_66288)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M15.1142 20.8125C14.9341 20.9926 14.6899 21.0939 14.4352 21.0939H12.5V19.1587C12.5 18.904 12.6013 18.6597 12.7814 18.4797L19.2823 11.9739C19.5923 11.6639 20.0128 11.4897 20.4512 11.4897C20.8895 11.4897 21.31 11.6639 21.62 11.9739C21.9302 12.2838 22.1045 12.7043 22.1045 13.1427C22.1045 13.5812 21.9302 14.0017 21.62 14.3115L15.1142 20.8125Z"
                        fill="white"
                        stroke="#323232"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.8838 14.3799L19.2176 16.7137L16.8838 14.3799Z"
                        fill="white"
                      />
                      <path
                        d="M16.8838 14.3799L19.2176 16.7137"
                        stroke="#323232"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M20.8728 15.0579L21.7371 15.9222C22.1921 16.3781 22.1921 17.1163 21.7371 17.5722L20.1611 19.1482"
                        fill="white"
                      />
                      <path
                        d="M20.8728 15.0579L21.7371 15.9222V15.9222C22.1921 16.3781 22.1921 17.1163 21.7371 17.5722L20.1611 19.1482"
                        stroke="#323232"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M9.61885 21.0938H6.73765C5.1464 21.0938 3.85645 19.8039 3.85645 18.2126V6.68784C3.85645 5.0966 5.1464 3.80664 6.73765 3.80664H18.2624C19.8537 3.80664 21.1436 5.0966 21.1436 6.68784V8.60864"
                        fill="white"
                      />
                      <path
                        d="M9.61885 21.0938H6.73765C5.1464 21.0938 3.85645 19.8039 3.85645 18.2126V6.68784C3.85645 5.0966 5.1464 3.80664 6.73765 3.80664H18.2624C19.8537 3.80664 21.1436 5.0966 21.1436 6.68784V8.60864"
                        stroke="#323232"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.69824 9.56907H13.4606H7.69824Z"
                        fill="white"
                      />
                      <path
                        d="M7.69824 9.56907H13.4606"
                        stroke="#323232"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.69824 13.4106H11.5398H7.69824Z"
                        fill="white"
                      />
                      <path
                        d="M7.69824 13.4106H11.5398"
                        stroke="#323232"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <filter
                        id="filter0_d_1568_66288"
                        x="3.10645"
                        y="3.05664"
                        width="20.748"
                        height="19.7874"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset dx="1" dy="1" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="BackgroundImageFix"
                          result="effect1_dropShadow_1568_66288"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="effect1_dropShadow_1568_66288"
                          result="shape"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div className="text-[18px] font-semibold">
                  Frictionless Smart Contract Transactions
                </div>
                <div className="#5A5A5A text-xs">
                  All transactions are executed by smart contracts on the
                  blockchain, making every transaction faster, more reliable and
                  cost efficient than ever before.
                </div>
              </div>

              <div className="rounded-lg text-center w-[300px] min-h-[250px] justify-between p-4 border-[1px] bg-white flex flex-col items-center">
                <div className="rounded-md bg-[#5b1dee] p-2">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.5011 9.99951V17.5026C15.5011 18.8839 12.8137 20.0037 9.49859 20.0037C6.1835 20.0037 3.49609 18.8839 3.49609 17.5026V9.99951"
                      fill="white"
                    />
                    <path
                      d="M15.5011 9.99951V17.5026C15.5011 18.8839 12.8137 20.0037 9.49859 20.0037C6.1835 20.0037 3.49609 18.8839 3.49609 17.5026V9.99951"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <ellipse
                      cx="9.49859"
                      cy="9.99909"
                      rx="6.0025"
                      ry="2.50104"
                      fill="white"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M22 7.5L15.5 9.89981V16.4998L22 14.7V7.5Z"
                      fill="white"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21.5045 6.49805V14.0012C21.5045 15.3825 18.817 16.5022 15.502 16.5022"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.99923 7.50804C9.70224 7.25311 9.52168 6.88837 9.49902 6.49762C9.49902 5.11705 12.1901 3.99658 15.5015 3.99658C18.8129 3.99658 21.504 5.11705 21.504 6.49762C21.504 7.8782 18.8129 8.99867 15.5015 8.99867C15.3315 8.99867 15.1614 8.99867 15.0013 8.98866"
                      fill="white"
                    />
                    <path
                      d="M9.99923 7.50804C9.70224 7.25311 9.52168 6.88837 9.49902 6.49762C9.49902 5.11705 12.1901 3.99658 15.5015 3.99658C18.8129 3.99658 21.504 5.11705 21.504 6.49762C21.504 7.8782 18.8129 8.99867 15.5015 8.99867C15.3315 8.99867 15.1614 8.99867 15.0013 8.98866"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.5011 13.501C15.5011 14.8823 12.8137 16.002 9.49859 16.002C6.1835 16.002 3.49609 14.8823 3.49609 13.501"
                      fill="white"
                    />
                    <path
                      d="M15.5011 13.501C15.5011 14.8823 12.8137 16.002 9.49859 16.002C6.1835 16.002 3.49609 14.8823 3.49609 13.501"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21.5045 9.99951C21.5045 11.3808 18.817 12.5006 15.502 12.5006L21.5045 9.99951Z"
                      fill="white"
                    />
                    <path
                      d="M21.5045 9.99951C21.5045 11.3808 18.817 12.5006 15.502 12.5006"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="text-[18px] font-semibold">
                  The Lowest Prices Across Web2 and Web3
                </div>
                <div className="#5A5A5A text-xs">
                  Buy,sell,trade and book accommodations wuth complete
                  transparency and no hidden fees. Coded Estate ensures the most
                  competitive prices for real estate investment, speculation and
                  travel bookings, backend by AI verifiable comparisons and
                  cost-efficient smart contract transactions
                </div>
              </div>

              <div className="rounded-lg text-center w-[300px] min-h-[250px] gap-3 p-4 border-[1px] bg-white flex flex-col items-center">
                <div className="rounded-md bg-[#5b1dee] p-2">
                  <svg
                    width="26"
                    height="28"
                    viewBox="0 0 26 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M14.5238 7.39842V5.29629C14.824 5.08263 15.0771 4.80756 15.2657 4.48809L14.8351 4.23391L15.2657 4.48809C15.5063 4.08038 15.6332 3.61532 15.6331 3.14167L14.5238 7.39842ZM14.5238 7.39842C15.8546 7.70672 17.0341 8.40924 17.9341 9.37564L19.7449 8.32603C19.779 7.95854 19.8897 7.60106 20.071 7.27723C20.3024 6.8641 20.6404 6.52086 21.0498 6.28372L14.5238 7.39842ZM1.78244 7.49829L1.35269 7.2511C2.07916 5.98812 3.69051 5.55321 4.95085 6.28392C5.3602 6.52106 5.69819 6.86429 5.92954 7.2774C6.11091 7.60123 6.22154 7.95871 6.25565 8.3262L8.0664 9.37578C8.96634 8.40918 10.1456 7.70679 11.4762 7.39848V5.2964C11.1761 5.08268 10.9231 4.80755 10.7345 4.48805L11.1651 4.23394L10.7345 4.48804C10.4939 4.08033 10.3671 3.61528 10.3673 3.14167L1.78244 7.49829ZM1.78244 7.49829L1.35269 7.2511C0.626789 8.51309 1.0568 10.1284 2.31613 10.8585L1.78244 7.49829ZM19.7513 14.0001C19.752 13.3289 19.6532 12.6621 19.4586 12.0215L21.269 10.9721C21.603 11.1258 21.9667 11.2083 22.3366 11.2126C22.8095 11.218 23.2751 11.0956 23.6844 10.8583C24.9438 10.1283 25.3736 8.51326 24.6478 7.25099C23.9213 5.98755 22.3104 5.55316 21.0499 6.28364L15.1331 24.8584M19.7513 14.0001C19.752 14.6712 19.6531 15.3378 19.4586 15.9783L21.2689 17.0276C21.603 16.8739 21.9666 16.7915 22.3366 16.7873C22.8094 16.7819 23.2749 16.9044 23.6842 17.1418C24.9436 17.8717 25.3736 19.4872 24.6476 20.7491C23.9211 22.0118 22.3101 22.4471 21.0497 21.7164C20.6403 21.4792 20.3023 21.136 20.0709 20.7228C19.8895 20.399 19.7789 20.0415 19.7448 19.6741L17.934 18.6244C17.0341 19.5909 15.8548 20.2936 14.5241 20.6018V22.7035C14.8243 22.9172 15.0773 23.1924 15.2659 23.5119C15.5066 23.9198 15.6333 24.3849 15.6331 24.8587M19.7513 14.0001C19.7513 13.9999 19.7513 13.9997 19.7513 13.9995L19.2513 14L19.7513 14.0006C19.7513 14.0004 19.7513 14.0002 19.7513 14.0001ZM15.6331 24.8587L15.1331 24.8584M15.6331 24.8587C15.6331 24.8586 15.6331 24.8585 15.6331 24.8584H15.1331M15.6331 24.8587C15.6329 26.3157 14.4556 27.5001 12.9999 27.5001C11.5442 27.5001 10.3675 26.316 10.3673 24.8587M15.1331 24.8584C15.1331 26.0412 14.1777 27.0001 12.9999 27.0001C11.8222 27.0001 10.8673 26.0417 10.8673 24.8584M10.3673 24.8587L10.8673 24.8584M10.3673 24.8587C10.3673 24.8586 10.3673 24.8585 10.3673 24.8584H10.8673M10.3673 24.8587C10.3671 24.385 10.4938 23.9198 10.7345 23.512C10.923 23.1924 11.1761 22.9173 11.4762 22.7035V20.6021M10.8673 24.8584L11.4762 20.6021M11.4762 20.6021C11.6141 20.6341 11.7536 20.6618 11.8946 20.6851L11.9762 20.1918H11.4762V20.6021ZM8.06614 18.6248L8.42215 18.4185L8.17142 17.9859L7.7848 18.3029C7.87522 18.4132 7.96905 18.5205 8.06614 18.6248ZM6.25542 19.6743C6.26482 19.5729 6.2684 19.4708 6.26604 19.3684L5.76617 19.38L6.0169 19.8126L6.25542 19.6743ZM4.95093 21.7166C4.95095 21.7165 4.95097 21.7165 4.95098 21.7165L4.70023 21.2839L4.95093 21.7166ZM2.3162 17.1421L2.56702 17.5745L2.31627 17.1421C2.31624 17.1421 2.31622 17.1421 2.3162 17.1421ZM4.74264 17.5994L5.00333 17.1728C4.91539 17.119 4.82465 17.0707 4.73163 17.0279L4.49188 17.1668L4.74264 17.5994ZM6.54215 15.9784C6.58329 16.1138 6.6287 16.248 6.67836 16.3809L7.14672 16.2058L6.89596 15.7733L6.54215 15.9784ZM6.24922 14.0001C6.24922 14.0003 6.24922 14.0005 6.24922 14.0007L6.74922 14L6.24922 13.9996C6.24922 13.9997 6.24922 13.9999 6.24922 14.0001ZM6.54178 12.0215L6.89556 12.2266L7.1463 11.794L6.67791 11.619C6.62828 11.7519 6.58289 11.8861 6.54178 12.0215ZM4.73151 10.9722C4.82454 10.9294 4.91528 10.881 5.00322 10.8273L4.74247 10.4007L4.49173 10.8333L4.73151 10.9722ZM13.0005 0.5C11.5448 0.5 10.3674 1.68441 10.3673 3.14145L15.6331 3.14152C15.633 1.6846 14.4563 0.5 13.0005 0.5ZM13.0002 9.91961C15.2419 9.91961 17.0626 11.7446 17.0626 14C17.0626 16.2555 15.2419 18.0805 13.0002 18.0805C10.7585 18.0805 8.93784 16.2555 8.93784 14C8.93784 11.7446 10.7585 9.91961 13.0002 9.91961Z"
                      fill="white"
                      stroke="#323232"
                    />
                  </svg>
                </div>
                <div className="text-[18px] font-semibold">
                  Fully decentralized process
                </div>
                <div className="#5A5A5A text-xs">
                  Coded Estate is a DeFi dApp built on a 100% decentralized
                  infrastructure, meaning every user hold custody of their own
                  assets by simply connecting their Web3 Wallet to our platform.
                </div>
              </div>

              <div className="rounded-lg text-center w-[300px] min-h-[200px] gap-3 p-4 border-[1px] bg-white flex flex-col items-center">
                <div className="rounded-md bg-[#5b1dee] p-2">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21.5041 15.6704V18.8918V15.6704Z"
                      fill="white"
                    />
                    <path
                      d="M21.5041 15.6704V18.8918"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M21.5025 7.27524V10.4966H21.5035C21.0368 10.4024 20.5535 10.4338 20.1029 10.5876C19.2655 10.8739 18.6302 11.565 18.4152 12.4234C18.213 13.2145 18.3874 14.0546 18.8879 14.6998C19.3884 15.345 20.1587 15.7229 20.9753 15.7238C21.1526 15.7235 21.3296 15.7057 21.5035 15.6707V18.8921C21.5035 19.4522 21.281 19.9894 20.885 20.3855C20.4889 20.7815 19.9517 21.004 19.3916 21.004H16.1703V21.005C16.2644 20.5383 16.233 20.0549 16.0792 19.6044C15.7929 18.767 15.1019 18.1317 14.2434 17.9167C13.4524 17.7145 12.6122 17.8889 11.967 18.3894C11.3218 18.8898 10.9439 19.6602 10.9431 20.4767C10.9434 20.6541 10.9611 20.8311 10.9961 21.005L7.77576 21.004C6.6097 21.0042 5.66422 20.0591 5.66388 18.8931V15.6717C5.48997 15.7067 5.31304 15.7245 5.13566 15.7248C4.31913 15.7239 3.54876 15.346 3.0483 14.7008C2.54783 14.0556 2.37338 13.2155 2.57559 12.4244C2.79062 11.566 3.42592 10.8749 4.26329 10.5886C4.71386 10.4348 5.19719 10.4034 5.66388 10.4976H5.66288V7.27624C5.66283 6.71613 5.88532 6.17894 6.28138 5.78287C6.67745 5.38681 7.21464 5.16432 7.77476 5.16436H10.9961C10.9611 4.99046 10.9434 4.81353 10.9431 4.63614C10.9439 3.81961 11.3218 3.04924 11.967 2.54878C12.6122 2.04832 13.4524 1.87386 14.2434 2.07608C15.1016 2.29172 15.7923 2.92679 16.0792 3.76378C16.233 4.21435 16.2644 4.69768 16.1703 5.16436H19.3916C19.9517 5.16432 20.4889 5.38681 20.885 5.78287C21.281 6.17894 21.5035 6.71613 21.5035 7.27624"
                      fill="white"
                    />
                    <path
                      d="M21.5025 7.27524V10.4966H21.5035C21.0368 10.4024 20.5535 10.4338 20.1029 10.5876C19.2655 10.8739 18.6302 11.565 18.4152 12.4234C18.213 13.2145 18.3874 14.0546 18.8879 14.6998C19.3884 15.345 20.1587 15.7229 20.9753 15.7238C21.1526 15.7235 21.3296 15.7057 21.5035 15.6707V18.8921C21.5035 19.4522 21.281 19.9894 20.885 20.3855C20.4889 20.7815 19.9517 21.004 19.3916 21.004H16.1703V21.005C16.2644 20.5383 16.233 20.0549 16.0792 19.6044C15.7929 18.767 15.1019 18.1317 14.2434 17.9167C13.4524 17.7145 12.6122 17.8889 11.967 18.3894C11.3218 18.8898 10.9439 19.6602 10.9431 20.4767C10.9434 20.6541 10.9611 20.8311 10.9961 21.005L7.77576 21.004C6.6097 21.0042 5.66422 20.0591 5.66388 18.8931V15.6717C5.48997 15.7067 5.31304 15.7245 5.13566 15.7248C4.31913 15.7239 3.54876 15.346 3.0483 14.7008C2.54783 14.0556 2.37338 13.2155 2.57559 12.4244C2.79062 11.566 3.42592 10.8749 4.26329 10.5886C4.71386 10.4348 5.19719 10.4034 5.66388 10.4976H5.66288V7.27624C5.66283 6.71613 5.88532 6.17894 6.28138 5.78287C6.67745 5.38681 7.21464 5.16432 7.77476 5.16436H10.9961C10.9611 4.99046 10.9434 4.81353 10.9431 4.63614C10.9439 3.81961 11.3218 3.04924 11.967 2.54878C12.6122 2.04832 13.4524 1.87386 14.2434 2.07608C15.1016 2.29172 15.7923 2.92679 16.0792 3.76378C16.233 4.21435 16.2644 4.69768 16.1703 5.16436H19.3916C19.9517 5.16432 20.4889 5.38681 20.885 5.78287C21.281 6.17894 21.5035 6.71613 21.5035 7.27624"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="text-[18px] font-semibold">
                  Remove barriers to real estate investments
                </div>
                <div className="#5A5A5A text-xs">
                  Democratising access to home ownership and real estate
                  speculation $1 at a time.
                </div>
              </div>

              <div className="rounded-lg text-center w-[300px] min-h-[200px] gap-3 p-4 border-[1px] bg-white flex flex-col items-center">
                <div className="rounded-md bg-[#5b1dee] p-2">
                  <svg
                    width="25"
                    height="24"
                    viewBox="0 0 25 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M2.8577 6.43301L12.5 0.866025L22.1423 6.43301V17.567L12.5 23.134L2.8577 17.567V6.43301Z"
                      fill="white"
                      stroke="#323232"
                      stroke-width="1.5"
                    />
                    <path
                      d="M7.72502 14H6.5V10H7.80973L9.02823 11.797L9.31494 12.2866H9.39965L9.33449 11.797V10H10.553V14H9.24978L8.09644 12.3343L7.74457 11.7672H7.65986L7.72502 12.3343V14Z"
                      fill="#323232"
                    />
                    <path
                      d="M12.2621 14H11.0371V10H14.4189V11.009H12.2621V11.6657H14.3212V12.6687H12.2621V14Z"
                      fill="#323232"
                    />
                    <path
                      d="M17.1577 14H15.9327V11.009H14.5904V10H18.5V11.009H17.1577V14Z"
                      fill="#323232"
                    />
                  </svg>
                </div>
                <div className="text-[18px] font-semibold">
                  Real world assets in NFTs
                </div>
                <div className="#5A5A5A text-xs">
                  Own your real estate deeds off-chain, represented by dynamic
                  NFTs on-chain.
                </div>
              </div>

              <div className="rounded-lg text-center w-[300px] min-h-[200px] gap-3 p-4 border-[1px] bg-white flex flex-col items-center">
                <div className="rounded-md bg-[#5b1dee] p-2">
                  <svg
                    width="24"
                    height="21"
                    viewBox="0 0 24 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12.6666 2.74547L12.5 2.89453V3.11805V5V5.5H13H18C19.3808 5.5 20.5 6.61929 20.5 8V18C20.5 19.3808 19.3808 20.5 18 20.5H6C4.61929 20.5 3.5 19.3808 3.5 18V8C3.5 6.61929 4.61929 5.5 6 5.5H11H11.5V5V3.11805V2.89453L11.3334 2.74547C11.1281 2.56166 11 2.29614 11 2C11 1.44772 11.4477 1 12 1C12.5523 1 13 1.44772 13 2C13 2.29614 12.8719 2.56166 12.6666 2.74547ZM0.5 10.5H1.5V15.5H0.5V10.5ZM22.5 15.5V10.5H23.5V15.5H22.5ZM9 15C10.1046 15 11 14.1045 11 13C11 11.8955 10.1046 11 9 11C7.89542 11 7 11.8955 7 13C7 14.1045 7.89542 15 9 15ZM17 13C17 11.8955 16.1045 11 15 11C13.8955 11 13 11.8955 13 13C13 14.1045 13.8955 15 15 15C16.1045 15 17 14.1045 17 13Z"
                      fill="white"
                      stroke="#323232"
                    />
                  </svg>
                </div>

                <div className="text-[18px] font-semibold">Coded AI-Agent</div>
                <div className="#5A5A5A text-xs">
                  The Coded AI-Agent is a cutting-edge aritificial intelligence
                  solution designed to automate platform processes while
                  providing personalized guidance with the best advice and
                  cheapest options across all Coded Estate products.
                </div>
              </div>
            </div>
          </div>

          {/* <img src={image_card} alt="" className="sm:hidden block w-[90vw]" /> */}
          <div className="sm:hidden block w-[90vw] space-y-4 mb-4 bg-[#F0F0F0FF] p-4 rounded-md">
            <div className="rounded-lg text-center w-full justify-between p-4 border-[1px] bg-white flex flex-col items-center">
              <div className="rounded-md bg-[#5b1dee] p-2">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_d_1568_66288)">
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M15.1142 20.8125C14.9341 20.9926 14.6899 21.0939 14.4352 21.0939H12.5V19.1587C12.5 18.904 12.6013 18.6597 12.7814 18.4797L19.2823 11.9739C19.5923 11.6639 20.0128 11.4897 20.4512 11.4897C20.8895 11.4897 21.31 11.6639 21.62 11.9739C21.9302 12.2838 22.1045 12.7043 22.1045 13.1427C22.1045 13.5812 21.9302 14.0017 21.62 14.3115L15.1142 20.8125Z"
                      fill="white"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.8838 14.3799L19.2176 16.7137L16.8838 14.3799Z"
                      fill="white"
                    />
                    <path
                      d="M16.8838 14.3799L19.2176 16.7137"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M20.8728 15.0579L21.7371 15.9222C22.1921 16.3781 22.1921 17.1163 21.7371 17.5722L20.1611 19.1482"
                      fill="white"
                    />
                    <path
                      d="M20.8728 15.0579L21.7371 15.9222V15.9222C22.1921 16.3781 22.1921 17.1163 21.7371 17.5722L20.1611 19.1482"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.61885 21.0938H6.73765C5.1464 21.0938 3.85645 19.8039 3.85645 18.2126V6.68784C3.85645 5.0966 5.1464 3.80664 6.73765 3.80664H18.2624C19.8537 3.80664 21.1436 5.0966 21.1436 6.68784V8.60864"
                      fill="white"
                    />
                    <path
                      d="M9.61885 21.0938H6.73765C5.1464 21.0938 3.85645 19.8039 3.85645 18.2126V6.68784C3.85645 5.0966 5.1464 3.80664 6.73765 3.80664H18.2624C19.8537 3.80664 21.1436 5.0966 21.1436 6.68784V8.60864"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.69824 9.56907H13.4606H7.69824Z"
                      fill="white"
                    />
                    <path
                      d="M7.69824 9.56907H13.4606"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.69824 13.4106H11.5398H7.69824Z"
                      fill="white"
                    />
                    <path
                      d="M7.69824 13.4106H11.5398"
                      stroke="#323232"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_d_1568_66288"
                      x="3.10645"
                      y="3.05664"
                      width="20.748"
                      height="19.7874"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1" dy="1" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_1568_66288"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_1568_66288"
                        result="shape"
                      />
                    </filter>
                  </defs>
                </svg>
              </div>
              <div className="  text-[18px] font-semibold">
                Frictionless Smart Contract Transactions
              </div>
              <div className="text-[#5A5A5A]">
                All transactions are executed by smart contracts on the
                blockchain, making every transaction faster, more reliable and
                cost efficient than ever before.
              </div>
            </div>
            <div className="rounded-lg text-center w-full justify-between p-4 border-[1px] bg-white flex flex-col items-center">
              <div className="rounded-md bg-[#5b1dee] p-2">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.5011 9.99951V17.5026C15.5011 18.8839 12.8137 20.0037 9.49859 20.0037C6.1835 20.0037 3.49609 18.8839 3.49609 17.5026V9.99951"
                    fill="white"
                  />
                  <path
                    d="M15.5011 9.99951V17.5026C15.5011 18.8839 12.8137 20.0037 9.49859 20.0037C6.1835 20.0037 3.49609 18.8839 3.49609 17.5026V9.99951"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <ellipse
                    cx="9.49859"
                    cy="9.99909"
                    rx="6.0025"
                    ry="2.50104"
                    fill="white"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M22 7.5L15.5 9.89981V16.4998L22 14.7V7.5Z"
                    fill="white"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.5045 6.49805V14.0012C21.5045 15.3825 18.817 16.5022 15.502 16.5022"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M9.99923 7.50804C9.70224 7.25311 9.52168 6.88837 9.49902 6.49762C9.49902 5.11705 12.1901 3.99658 15.5015 3.99658C18.8129 3.99658 21.504 5.11705 21.504 6.49762C21.504 7.8782 18.8129 8.99867 15.5015 8.99867C15.3315 8.99867 15.1614 8.99867 15.0013 8.98866"
                    fill="white"
                  />
                  <path
                    d="M9.99923 7.50804C9.70224 7.25311 9.52168 6.88837 9.49902 6.49762C9.49902 5.11705 12.1901 3.99658 15.5015 3.99658C18.8129 3.99658 21.504 5.11705 21.504 6.49762C21.504 7.8782 18.8129 8.99867 15.5015 8.99867C15.3315 8.99867 15.1614 8.99867 15.0013 8.98866"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M15.5011 13.501C15.5011 14.8823 12.8137 16.002 9.49859 16.002C6.1835 16.002 3.49609 14.8823 3.49609 13.501"
                    fill="white"
                  />
                  <path
                    d="M15.5011 13.501C15.5011 14.8823 12.8137 16.002 9.49859 16.002C6.1835 16.002 3.49609 14.8823 3.49609 13.501"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.5045 9.99951C21.5045 11.3808 18.817 12.5006 15.502 12.5006L21.5045 9.99951Z"
                    fill="white"
                  />
                  <path
                    d="M21.5045 9.99951C21.5045 11.3808 18.817 12.5006 15.502 12.5006"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="text-[18px] font-semibold">
                The Lowest Prices Across Web2 and Web3
              </div>
              <div className="text-[#5A5A5A]">
                Buy,sell,trade and book accommodations wuth complete
                transparency and no hidden fees. Coded Estate ensures the most
                competitive prices for real estate investment, speculation and
                travel bookings, backend by AI verifiable comparisons and
                cost-efficient smart contract transactions
              </div>
            </div>

            <div className="rounded-lg text-center w-full justify-between p-4 border-[1px] bg-white flex flex-col items-center">
              <div className="rounded-md bg-[#5b1dee] p-2">
                <svg
                  width="26"
                  height="28"
                  viewBox="0 0 26 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.5238 7.39842V5.29629C14.824 5.08263 15.0771 4.80756 15.2657 4.48809L14.8351 4.23391L15.2657 4.48809C15.5063 4.08038 15.6332 3.61532 15.6331 3.14167L14.5238 7.39842ZM14.5238 7.39842C15.8546 7.70672 17.0341 8.40924 17.9341 9.37564L19.7449 8.32603C19.779 7.95854 19.8897 7.60106 20.071 7.27723C20.3024 6.8641 20.6404 6.52086 21.0498 6.28372L14.5238 7.39842ZM1.78244 7.49829L1.35269 7.2511C2.07916 5.98812 3.69051 5.55321 4.95085 6.28392C5.3602 6.52106 5.69819 6.86429 5.92954 7.2774C6.11091 7.60123 6.22154 7.95871 6.25565 8.3262L8.0664 9.37578C8.96634 8.40918 10.1456 7.70679 11.4762 7.39848V5.2964C11.1761 5.08268 10.9231 4.80755 10.7345 4.48805L11.1651 4.23394L10.7345 4.48804C10.4939 4.08033 10.3671 3.61528 10.3673 3.14167L1.78244 7.49829ZM1.78244 7.49829L1.35269 7.2511C0.626789 8.51309 1.0568 10.1284 2.31613 10.8585L1.78244 7.49829ZM19.7513 14.0001C19.752 13.3289 19.6532 12.6621 19.4586 12.0215L21.269 10.9721C21.603 11.1258 21.9667 11.2083 22.3366 11.2126C22.8095 11.218 23.2751 11.0956 23.6844 10.8583C24.9438 10.1283 25.3736 8.51326 24.6478 7.25099C23.9213 5.98755 22.3104 5.55316 21.0499 6.28364L15.1331 24.8584M19.7513 14.0001C19.752 14.6712 19.6531 15.3378 19.4586 15.9783L21.2689 17.0276C21.603 16.8739 21.9666 16.7915 22.3366 16.7873C22.8094 16.7819 23.2749 16.9044 23.6842 17.1418C24.9436 17.8717 25.3736 19.4872 24.6476 20.7491C23.9211 22.0118 22.3101 22.4471 21.0497 21.7164C20.6403 21.4792 20.3023 21.136 20.0709 20.7228C19.8895 20.399 19.7789 20.0415 19.7448 19.6741L17.934 18.6244C17.0341 19.5909 15.8548 20.2936 14.5241 20.6018V22.7035C14.8243 22.9172 15.0773 23.1924 15.2659 23.5119C15.5066 23.9198 15.6333 24.3849 15.6331 24.8587M19.7513 14.0001C19.7513 13.9999 19.7513 13.9997 19.7513 13.9995L19.2513 14L19.7513 14.0006C19.7513 14.0004 19.7513 14.0002 19.7513 14.0001ZM15.6331 24.8587L15.1331 24.8584M15.6331 24.8587C15.6331 24.8586 15.6331 24.8585 15.6331 24.8584H15.1331M15.6331 24.8587C15.6329 26.3157 14.4556 27.5001 12.9999 27.5001C11.5442 27.5001 10.3675 26.316 10.3673 24.8587M15.1331 24.8584C15.1331 26.0412 14.1777 27.0001 12.9999 27.0001C11.8222 27.0001 10.8673 26.0417 10.8673 24.8584M10.3673 24.8587L10.8673 24.8584M10.3673 24.8587C10.3673 24.8586 10.3673 24.8585 10.3673 24.8584H10.8673M10.3673 24.8587C10.3671 24.385 10.4938 23.9198 10.7345 23.512C10.923 23.1924 11.1761 22.9173 11.4762 22.7035V20.6021M10.8673 24.8584L11.4762 20.6021M11.4762 20.6021C11.6141 20.6341 11.7536 20.6618 11.8946 20.6851L11.9762 20.1918H11.4762V20.6021ZM8.06614 18.6248L8.42215 18.4185L8.17142 17.9859L7.7848 18.3029C7.87522 18.4132 7.96905 18.5205 8.06614 18.6248ZM6.25542 19.6743C6.26482 19.5729 6.2684 19.4708 6.26604 19.3684L5.76617 19.38L6.0169 19.8126L6.25542 19.6743ZM4.95093 21.7166C4.95095 21.7165 4.95097 21.7165 4.95098 21.7165L4.70023 21.2839L4.95093 21.7166ZM2.3162 17.1421L2.56702 17.5745L2.31627 17.1421C2.31624 17.1421 2.31622 17.1421 2.3162 17.1421ZM4.74264 17.5994L5.00333 17.1728C4.91539 17.119 4.82465 17.0707 4.73163 17.0279L4.49188 17.1668L4.74264 17.5994ZM6.54215 15.9784C6.58329 16.1138 6.6287 16.248 6.67836 16.3809L7.14672 16.2058L6.89596 15.7733L6.54215 15.9784ZM6.24922 14.0001C6.24922 14.0003 6.24922 14.0005 6.24922 14.0007L6.74922 14L6.24922 13.9996C6.24922 13.9997 6.24922 13.9999 6.24922 14.0001ZM6.54178 12.0215L6.89556 12.2266L7.1463 11.794L6.67791 11.619C6.62828 11.7519 6.58289 11.8861 6.54178 12.0215ZM4.73151 10.9722C4.82454 10.9294 4.91528 10.881 5.00322 10.8273L4.74247 10.4007L4.49173 10.8333L4.73151 10.9722ZM13.0005 0.5C11.5448 0.5 10.3674 1.68441 10.3673 3.14145L15.6331 3.14152C15.633 1.6846 14.4563 0.5 13.0005 0.5ZM13.0002 9.91961C15.2419 9.91961 17.0626 11.7446 17.0626 14C17.0626 16.2555 15.2419 18.0805 13.0002 18.0805C10.7585 18.0805 8.93784 16.2555 8.93784 14C8.93784 11.7446 10.7585 9.91961 13.0002 9.91961Z"
                    fill="white"
                    stroke="#323232"
                  />
                </svg>
              </div>
              <div className="text-[18px] font-semibold">
                Fully decentralized process
              </div>
              <div className="text-[#5A5A5A]">
                Coded Estate is a DeFi dApp built on a 100% decentralized
                infrastructure, meaning every user hold custody of their own
                assets by simply connecting their Web3 Wallet to our platform.
              </div>
            </div>

            <div className="rounded-lg text-center w-full justify-between p-4 border-[1px] bg-white flex flex-col items-center">
              <div className="rounded-md bg-[#5b1dee] p-2">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.5041 15.6704V18.8918V15.6704Z"
                    fill="white"
                  />
                  <path
                    d="M21.5041 15.6704V18.8918"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M21.5025 7.27524V10.4966H21.5035C21.0368 10.4024 20.5535 10.4338 20.1029 10.5876C19.2655 10.8739 18.6302 11.565 18.4152 12.4234C18.213 13.2145 18.3874 14.0546 18.8879 14.6998C19.3884 15.345 20.1587 15.7229 20.9753 15.7238C21.1526 15.7235 21.3296 15.7057 21.5035 15.6707V18.8921C21.5035 19.4522 21.281 19.9894 20.885 20.3855C20.4889 20.7815 19.9517 21.004 19.3916 21.004H16.1703V21.005C16.2644 20.5383 16.233 20.0549 16.0792 19.6044C15.7929 18.767 15.1019 18.1317 14.2434 17.9167C13.4524 17.7145 12.6122 17.8889 11.967 18.3894C11.3218 18.8898 10.9439 19.6602 10.9431 20.4767C10.9434 20.6541 10.9611 20.8311 10.9961 21.005L7.77576 21.004C6.6097 21.0042 5.66422 20.0591 5.66388 18.8931V15.6717C5.48997 15.7067 5.31304 15.7245 5.13566 15.7248C4.31913 15.7239 3.54876 15.346 3.0483 14.7008C2.54783 14.0556 2.37338 13.2155 2.57559 12.4244C2.79062 11.566 3.42592 10.8749 4.26329 10.5886C4.71386 10.4348 5.19719 10.4034 5.66388 10.4976H5.66288V7.27624C5.66283 6.71613 5.88532 6.17894 6.28138 5.78287C6.67745 5.38681 7.21464 5.16432 7.77476 5.16436H10.9961C10.9611 4.99046 10.9434 4.81353 10.9431 4.63614C10.9439 3.81961 11.3218 3.04924 11.967 2.54878C12.6122 2.04832 13.4524 1.87386 14.2434 2.07608C15.1016 2.29172 15.7923 2.92679 16.0792 3.76378C16.233 4.21435 16.2644 4.69768 16.1703 5.16436H19.3916C19.9517 5.16432 20.4889 5.38681 20.885 5.78287C21.281 6.17894 21.5035 6.71613 21.5035 7.27624"
                    fill="white"
                  />
                  <path
                    d="M21.5025 7.27524V10.4966H21.5035C21.0368 10.4024 20.5535 10.4338 20.1029 10.5876C19.2655 10.8739 18.6302 11.565 18.4152 12.4234C18.213 13.2145 18.3874 14.0546 18.8879 14.6998C19.3884 15.345 20.1587 15.7229 20.9753 15.7238C21.1526 15.7235 21.3296 15.7057 21.5035 15.6707V18.8921C21.5035 19.4522 21.281 19.9894 20.885 20.3855C20.4889 20.7815 19.9517 21.004 19.3916 21.004H16.1703V21.005C16.2644 20.5383 16.233 20.0549 16.0792 19.6044C15.7929 18.767 15.1019 18.1317 14.2434 17.9167C13.4524 17.7145 12.6122 17.8889 11.967 18.3894C11.3218 18.8898 10.9439 19.6602 10.9431 20.4767C10.9434 20.6541 10.9611 20.8311 10.9961 21.005L7.77576 21.004C6.6097 21.0042 5.66422 20.0591 5.66388 18.8931V15.6717C5.48997 15.7067 5.31304 15.7245 5.13566 15.7248C4.31913 15.7239 3.54876 15.346 3.0483 14.7008C2.54783 14.0556 2.37338 13.2155 2.57559 12.4244C2.79062 11.566 3.42592 10.8749 4.26329 10.5886C4.71386 10.4348 5.19719 10.4034 5.66388 10.4976H5.66288V7.27624C5.66283 6.71613 5.88532 6.17894 6.28138 5.78287C6.67745 5.38681 7.21464 5.16432 7.77476 5.16436H10.9961C10.9611 4.99046 10.9434 4.81353 10.9431 4.63614C10.9439 3.81961 11.3218 3.04924 11.967 2.54878C12.6122 2.04832 13.4524 1.87386 14.2434 2.07608C15.1016 2.29172 15.7923 2.92679 16.0792 3.76378C16.233 4.21435 16.2644 4.69768 16.1703 5.16436H19.3916C19.9517 5.16432 20.4889 5.38681 20.885 5.78287C21.281 6.17894 21.5035 6.71613 21.5035 7.27624"
                    stroke="#323232"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <div className="text-[18px] font-semibold">
                Remove barriers to real estate investments
              </div>
              <div>
                Democratising access to home ownership and real estate
                speculation $1 at a time.
              </div>
            </div>

            <div className="rounded-lg text-center w-full justify-between p-4 border-[1px] bg-white flex flex-col items-center">
              <div className="rounded-md bg-[#5b1dee] p-2">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.8577 6.43301L12.5 0.866025L22.1423 6.43301V17.567L12.5 23.134L2.8577 17.567V6.43301Z"
                    fill="white"
                    stroke="#323232"
                    stroke-width="1.5"
                  />
                  <path
                    d="M7.72502 14H6.5V10H7.80973L9.02823 11.797L9.31494 12.2866H9.39965L9.33449 11.797V10H10.553V14H9.24978L8.09644 12.3343L7.74457 11.7672H7.65986L7.72502 12.3343V14Z"
                    fill="#323232"
                  />
                  <path
                    d="M12.2621 14H11.0371V10H14.4189V11.009H12.2621V11.6657H14.3212V12.6687H12.2621V14Z"
                    fill="#323232"
                  />
                  <path
                    d="M17.1577 14H15.9327V11.009H14.5904V10H18.5V11.009H17.1577V14Z"
                    fill="#323232"
                  />
                </svg>
              </div>
              <div className="text-[18px] font-semibold">
                Real world assets in NFTs
              </div>
              <div className="text-[#5A5A5A]">
                Own your real estate deeds off-chain, represented by dynamic
                NFTs on-chain.
              </div>
            </div>
            <div className="rounded-lg text-center w-full justify-between p-4 border-[1px] bg-white flex flex-col items-center">
              <div className="rounded-md bg-[#5b1dee] p-2">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 69 68"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g filter="url(#filter0_dii_193_88955)">
                    <rect
                      x="11.5"
                      y="12"
                      width="48"
                      height="48"
                      rx="6"
                      fill="#5B1DEE"
                    />
                    <rect
                      x="11.5"
                      y="12"
                      width="48"
                      height="48"
                      rx="6"
                      fill="url(#paint0_linear_193_88955)"
                      fill-opacity="0.2"
                    />
                    <path
                      d="M35 37C35 38.1046 34.1046 39 33 39C31.8954 39 31 38.1046 31 37C31 35.8954 31.8954 35 33 35C34.1046 35 35 35.8954 35 37Z"
                      fill="white"
                    />
                    <path
                      d="M41 37C41 38.1046 40.1046 39 39 39C37.8954 39 37 38.1046 37 37C37 35.8954 37.8954 35 39 35C40.1046 35 41 35.8954 41 37Z"
                      fill="white"
                    />
                    <path
                      d="M36.6666 26.7455L36.5 26.8945V27.1181V29V29.5H37H42C43.3808 29.5 44.5 30.6193 44.5 32V42C44.5 43.3808 43.3808 44.5 42 44.5H30C28.6193 44.5 27.5 43.3808 27.5 42V32C27.5 30.6193 28.6193 29.5 30 29.5H35H35.5V29V27.1181V26.8945L35.3334 26.7455C35.1281 26.5617 35 26.2961 35 26C35 25.4477 35.4477 25 36 25C36.5523 25 37 25.4477 37 26C37 26.2961 36.8719 26.5617 36.6666 26.7455ZM24.5 34.5H25.5V39.5H24.5V34.5ZM46.5 39.5V34.5H47.5V39.5H46.5ZM33 39C34.1046 39 35 38.1045 35 37C35 35.8955 34.1046 35 33 35C31.8954 35 31 35.8955 31 37C31 38.1045 31.8954 39 33 39ZM41 37C41 35.8955 40.1045 35 39 35C37.8955 35 37 35.8955 37 37C37 38.1045 37.8955 39 39 39C40.1045 39 41 38.1045 41 37Z"
                      fill="white"
                      stroke="#323232"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_dii_193_88955"
                      x="0.5"
                      y="0"
                      width="68"
                      height="68"
                      filterUnits="userSpaceOnUse"
                      color-interpolation-filters="sRGB"
                    >
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="-1" dy="-2" />
                      <feGaussianBlur stdDeviation="5" />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_193_88955"
                      />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_193_88955"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="1" dy="1" />
                      <feGaussianBlur stdDeviation="0.5" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0 0.666667 0 0 0 0.05 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect2_innerShadow_193_88955"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dx="-1" dy="-1" />
                      <feGaussianBlur stdDeviation="1" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="effect2_innerShadow_193_88955"
                        result="effect3_innerShadow_193_88955"
                      />
                    </filter>
                    <linearGradient
                      id="paint0_linear_193_88955"
                      x1="35.5"
                      y1="12"
                      x2="35.5"
                      y2="60"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stop-color="white" />
                      <stop offset="1" stop-color="white" stop-opacity="0" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <div className="text-[18px] font-semibold">Coded AI-Agent</div>
              <div className="text-[#5A5A5A]">
                The Coded AI-Agent is a cutting-edge aritificial intelligence
                solution designed to automate platform processes while providing
                personalized guidance with the best advice and cheapest options
                across all Coded Estate products.
              </div>
            </div>
          </div>

          <div className="sm:flex relative hidden items-center w-full pl-[20vw] my-[100px]">
            <div className="absolute max-w-[30vw] z-[50]">
              {/* <Fade direction="up"> */}
              <div className="text-[42px] font-semibold leading-none">
                Join the waitling-list <br /> of{" "}
                <span className="w-max relative">
                  Coded Estate
                  <svg
                    className="w-full absolute top-[30px] left-0 widthAnimation"
                    width="352"
                    height="32"
                    viewBox="0 0 352 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      width="352"
                      height="32"
                      fill="url(#paint0_linear_963_79931)"
                      fill-opacity="0.12"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_963_79931"
                        x1="101.689"
                        y1="16"
                        x2="107.865"
                        y2="-22.8301"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop offset="2.29095e-07" stop-color="#6317F7" />
                        <stop offset="1" stop-color="#18FFFF" />
                      </linearGradient>
                    </defs>
                  </svg>
                </span>
              </div>
              {/* </Fade> */}
              {/* <Fade> */}
              <div className="my-6">
                Sign up to join the waiting list of 100,000 super users to get
                first alpha on Coded Estate’s first product launch.
              </div>
              <div
                onClick={() => {
                  setJoinFlag(false);
                  setJoin(true);
                }}
                className="w-max select-none px-[14px] py-[8px] rounded-[12px] bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] text-white text-center cursor-pointer shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
              >
                Join Waitlist
              </div>
              {/* </Fade> */}
            </div>
            <LottieComponent animationData={joinJson} />
          </div>

          <Modal center>
            <div>
              <div className="absolute max-w-[90vw]">
                {/* <Fade direction="up"> */}
                <div className="text-[42px] font-semibold leading-none">
                  Join the waitling-list <br /> of{" "}
                  <span className="w-max relative">
                    Coded Estate
                    <svg
                      className="w-full absolute top-[30px] left-0 widthAnimation"
                      width="352"
                      height="32"
                      viewBox="0 0 352 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        width="352"
                        height="32"
                        fill="url(#paint0_linear_963_79931)"
                        fill-opacity="0.12"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_963_79931"
                          x1="101.689"
                          y1="16"
                          x2="107.865"
                          y2="-22.8301"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop offset="2.29095e-07" stop-color="#6317F7" />
                          <stop offset="1" stop-color="#18FFFF" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                </div>
                {/* </Fade> */}
                {/* <Fade> */}
                <div className="my-6">
                  Sign up to join the waiting list of 100,000 super users to get
                  first alpha on Coded Estate’s first product launch.
                </div>
                <div
                  onClick={() => setJoin(true)}
                  className="w-max select-none px-[14px] py-[8px] rounded-[12px] bg-gradient-to-b from-[#5b1deec0] from-0% to-70% to-[#5b1dee] text-white text-center cursor-pointer shadow-[2px_2px_6px_0px_rgba(187,195,206,0.6),-2px_-2px_6px_0px_rgba(253,255,255,0.8)]"
                >
                  Join Waitlist
                </div>
                {/* </Fade> */}
              </div>
            </div>
          </Modal>
          {/* <Fade direction="up" className="w-full"> */}
          <div className="bg-[#FAFAFA] sm:py-[100px] py-[30px] w-full flex flex-col items-center">
            <div className="flex sm:flex-row flex-col sm:w-[100vw] items-center justify-between">
              <svg
                width="118"
                height="38"
                viewBox="0 0 118 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_1395_81513)">
                  <path
                    d="M64.5417 15.2836C62.4848 15.2836 60.9277 13.6281 60.9277 11.4484C60.9277 9.30642 62.4848 7.66967 64.5417 7.66967C65.6892 7.66967 66.9489 8.32011 67.8026 9.36289L69.7099 7.09189C68.4124 5.75076 66.4113 4.89612 64.4853 4.89612C60.5402 4.89612 57.5574 7.72614 57.5574 11.486C57.5574 15.3024 60.4651 18.1862 64.3759 18.1862C66.2856 18.1862 68.3402 17.2375 69.7315 15.8023L67.8055 13.7543C66.896 14.687 65.6357 15.2836 64.5417 15.2836Z"
                    fill="#323260"
                  />
                  <path
                    d="M75.8204 18.1489C79.0813 18.1489 81.2697 16.101 81.2697 13.0102C81.2697 9.91952 79.0842 7.89038 75.8204 7.89038C72.541 7.89038 70.3555 9.91952 70.3555 13.0102C70.3555 16.1036 72.541 18.1489 75.8204 18.1489ZM75.8204 10.4436C77.1366 10.4436 78.0438 11.5052 78.0438 13.0505C78.0438 14.6147 77.1366 15.6575 75.8204 15.6575C74.4856 15.6575 73.5791 14.6147 73.5791 13.0505C73.5791 11.5052 74.4885 10.4436 75.8204 10.4436Z"
                    fill="#323260"
                  />
                  <path
                    d="M87.0166 18.1663C88.2955 18.1663 89.3144 17.6449 90.0185 16.715V18.0373H93.2228V4.22583H90.0185V9.32689C89.3144 8.39694 88.2583 7.87558 86.9421 7.87558C84.1811 7.87558 82.3464 9.90466 82.3464 12.9766C82.3488 16.0834 84.2003 18.1663 87.0166 18.1663ZM87.7951 10.4422C89.1299 10.4422 90.0185 11.5038 90.0185 13.0491C90.0185 14.5945 89.1299 15.6749 87.7951 15.6749C86.4603 15.6749 85.5724 14.5945 85.5537 13.0491C85.5724 11.5038 86.4603 10.4422 87.7951 10.4422Z"
                    fill="#323260"
                  />
                  <path
                    d="M100.32 18.1485C102.155 18.1485 103.656 17.4954 104.675 16.3801L102.99 14.7245C102.324 15.3937 101.471 15.7485 100.601 15.7485C99.4159 15.7485 98.5629 15.0793 98.2469 13.886H105.269C105.491 10.2202 103.75 7.8927 100.229 7.8927C97.1344 7.8927 95.0239 9.94067 95.0239 13.0502C95.021 16.1033 97.0593 18.1485 100.32 18.1485ZM100.264 10.1261C101.412 10.1261 102.19 10.927 102.19 12.1552H98.1882C98.3918 10.9458 99.1512 10.1261 100.264 10.1261Z"
                    fill="#323260"
                  />
                  <path
                    d="M113.986 4.22583V9.32689C113.283 8.39694 112.226 7.87558 110.91 7.87558C108.15 7.87558 106.314 9.90466 106.314 12.9766C106.314 16.0861 108.168 18.169 110.983 18.169C112.261 18.169 113.281 17.6476 113.984 16.7177V18.04H117.189V4.22853H113.986V4.22583ZM111.764 15.6722C110.429 15.6722 109.541 14.5918 109.522 13.0464C109.541 11.5011 110.429 10.4395 111.764 10.4395C113.099 10.4395 113.986 11.5011 113.986 13.0464C113.986 14.5918 113.099 15.6722 111.764 15.6722Z"
                    fill="#323260"
                  />
                  <path
                    d="M60.9042 27.713H67.4444V26.2805H60.9042V21.9992H68.223V20.5667H59.4221V33.5961H68.4639V32.1797H60.9042V27.713Z"
                    fill="#323260"
                  />
                  <path
                    d="M71.9757 26.2805C71.9757 25.3694 72.8101 24.977 73.9017 24.977C74.8083 24.977 75.7899 25.2941 76.5498 25.7779L77.1061 24.6249C76.2903 24.0659 75.1615 23.7326 73.9925 23.7326C72.2137 23.7326 70.6031 24.5147 70.6031 26.3933C70.5845 29.8738 76.0494 28.6643 75.9936 31.0294C75.9744 31.9969 75.0492 32.4269 73.8988 32.4269C72.7514 32.4269 71.491 31.962 70.6566 31.1799L70.1003 32.2792C71.0261 33.1714 72.454 33.6552 73.8424 33.6552C75.7125 33.6552 77.4192 32.8005 77.4192 30.8627C77.4215 27.342 71.9757 28.4574 71.9757 26.2805Z"
                    fill="#323260"
                  />
                  <path
                    d="M82.9355 32.2552C82.1006 32.2552 81.638 31.8091 81.638 30.6158V25.2729H84.733V24.0823L81.638 24.1012V21.513H80.2124V24.1012H78.8025V25.2756H80.2124V30.8792C80.2124 32.8143 81.2691 33.6716 82.6946 33.6716C83.4732 33.6528 84.2139 33.3921 84.8988 32.9271L84.4921 31.7527C83.9544 32.0886 83.4354 32.2552 82.9355 32.2552Z"
                    fill="#323260"
                  />
                  <path
                    d="M90.7473 23.7303C89.0802 23.7303 88.0241 24.2141 86.7638 25.0526L87.3765 26.1142C88.3959 25.4073 89.3961 24.9962 90.4685 24.9962C92.1915 24.9962 93.0823 25.8508 93.0823 27.286V27.8638H89.8774C87.5795 27.8826 86.229 28.9603 86.229 30.675C86.229 32.3682 87.5266 33.6717 89.5457 33.6717C91.1028 33.6717 92.3439 33.1503 93.1225 32.0886V33.5964H94.5324L94.5132 27.1193C94.4922 25.015 93.1574 23.7303 90.7473 23.7303ZM93.1009 30.2074C92.7291 31.5673 91.4694 32.4031 89.8215 32.4031C88.4494 32.4031 87.5795 31.6963 87.5795 30.6159C87.5795 29.5355 88.4331 29.0329 90.0624 29.0329H93.1009V30.2074Z"
                    fill="#323260"
                  />
                  <path
                    d="M100.484 32.2552C99.6487 32.2552 99.1861 31.8091 99.1861 30.6158V25.2729H102.281V24.0823L99.1861 24.1012V21.513H97.7605V24.1012H96.3506V25.2756H97.7605V30.8792C97.7605 32.8143 98.8172 33.6716 100.243 33.6716C101.021 33.6528 101.762 33.3921 102.447 32.9271L102.04 31.7527C101.503 32.0886 100.983 32.2552 100.484 32.2552Z"
                    fill="#323260"
                  />
                  <path
                    d="M108.186 23.749C105.351 23.749 103.35 25.7781 103.35 28.7022C103.35 31.6236 105.332 33.6527 108.206 33.6527C109.837 33.6527 111.207 33.0587 112.135 32.0159L111.338 31.1613C110.578 31.9622 109.521 32.3895 108.318 32.3895C106.429 32.3895 105.038 31.1801 104.779 29.2612H112.748C112.894 25.9259 111.338 23.7301 108.186 23.749ZM104.779 28.0679C105.001 26.2054 106.335 24.996 108.189 24.996C110.099 24.996 111.356 26.1866 111.45 28.0679H104.779Z"
                    fill="#323260"
                  />
                  <path
                    d="M18.897 35.7975L25.5417 1.52553C25.7343 0.536502 26.5448 -0.135392 27.3527 0.0231752C28.0454 0.157554 28.5109 0.85901 28.5109 1.67872C28.5109 1.81579 28.4976 1.95823 28.4708 2.10067L21.8261 36.3727C21.6335 37.3617 20.823 38.0336 20.0152 37.875C19.3224 37.7407 18.8569 37.0392 18.8569 36.2195C18.8569 36.0824 18.8703 35.94 18.897 35.7975Z"
                    fill="url(#paint0_linear_1395_81513)"
                  />
                  <path
                    d="M21.9475 6.984C21.8004 7.74727 21.1343 8.29821 20.3612 8.29821H13.3662L13.3368 8.3009L4.11877 18.9464L13.3528 29.6107L13.3662 29.5973H15.6025C16.619 29.5973 17.384 30.5299 17.1887 31.5324C17.0416 32.2956 16.3756 32.8466 15.6025 32.8466H13.3662C12.4995 32.8466 11.6568 32.5026 11.055 31.9005L1.67652 21.075C1.12013 20.4945 0.8125 19.7419 0.8125 18.9464C0.8125 18.1509 1.11745 17.3984 1.67652 16.8206L10.9748 6.081L11.0577 5.99232C11.6622 5.39297 12.5048 5.04895 13.3688 5.04895H20.3639C21.3778 5.04895 22.1428 5.98156 21.9475 6.984Z"
                    fill="url(#paint1_linear_1395_81513)"
                  />
                  <path
                    d="M36.3112 5.99525L39.3313 9.48102H43.7932C44.3924 9.48102 44.8792 9.97016 44.8792 10.5722V11.8568C44.8792 12.4589 44.3924 12.948 43.7932 12.948H42.3327L45.6897 16.8235C46.2461 17.404 46.5537 18.1565 46.5537 18.9493C46.5537 19.7449 46.2488 20.4974 45.6897 21.0752L36.3915 31.8121L36.3086 31.9008C35.704 32.5028 34.8614 32.8468 33.9947 32.8468H27.0023C25.9858 32.8468 25.2208 31.9142 25.4134 30.9118C25.5605 30.1485 26.2266 29.5975 27.0023 29.5975L34.0268 29.5948L43.2448 18.9493L34.0135 8.28507L33.9974 8.29846H31.7611C30.7446 8.29846 29.9796 7.36588 30.1748 6.36344C30.3219 5.60015 30.9881 5.04919 31.7611 5.04919H33.9974C34.8641 5.04919 35.7067 5.3959 36.3112 5.99525Z"
                    fill="url(#paint2_linear_1395_81513)"
                  />
                  <path
                    d="M33.591 15.7939L35.8755 18.4304C36.0118 18.5728 36.0867 18.7556 36.0867 18.9491C36.0867 19.1426 36.0118 19.3253 35.8755 19.4678L33.6097 22.0828L33.591 22.1043C33.4439 22.2495 33.2379 22.3355 33.0266 22.3355H31.4644C31.0899 22.3355 30.7876 22.0317 30.7876 21.6555V16.2427C30.7876 15.8665 31.0899 15.5627 31.4644 15.5627H33.0266C33.2379 15.5627 33.4439 15.6461 33.591 15.7939Z"
                    fill="url(#paint3_linear_1395_81513)"
                  />
                  <path
                    d="M14.9602 22.0876L12.1863 20.8459C12.0712 20.7949 11.9963 20.6793 11.9963 20.553V17.3414C11.9963 17.215 12.0712 17.0995 12.1863 17.0484L14.9602 15.8067C15.1368 15.7288 15.3347 15.7288 15.5113 15.8067L18.2852 17.0484C18.4002 17.0995 18.4752 17.215 18.4752 17.3414V20.553C18.4752 20.6793 18.4002 20.7949 18.2852 20.8459L15.5113 22.0876C15.3347 22.1682 15.1341 22.1682 14.9602 22.0876Z"
                    fill="url(#paint4_linear_1395_81513)"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_1395_81513"
                    x1="-9.45163"
                    y1="38.6873"
                    x2="49.6877"
                    y2="3.78787"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_1395_81513"
                    x1="-11.9067"
                    y1="34.53"
                    x2="47.2327"
                    y2="-0.36951"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_1395_81513"
                    x1="-7.00086"
                    y1="42.845"
                    x2="52.1385"
                    y2="7.94554"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_1395_81513"
                    x1="-7.21988"
                    y1="42.4687"
                    x2="51.9195"
                    y2="7.56926"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                  <linearGradient
                    id="paint4_linear_1395_81513"
                    x1="-11.6507"
                    y1="34.9636"
                    x2="47.4886"
                    y2="0.0641321"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop offset="2.29095e-07" stop-color="#6317F7" />
                    <stop offset="1" stop-color="#18FFFF" />
                  </linearGradient>
                  <clipPath id="clip0_1395_81513">
                    <rect
                      width="116.375"
                      height="38"
                      fill="white"
                      transform="translate(0.8125)"
                    />
                  </clipPath>
                </defs>
              </svg>

              <div className="flex items-center sm:gap-3 gap-2 bg-[#fafafa]">
                <div
                  className="whitespace-nowrap p-2 rounded-xl text-[#202020] hover:bg-gray-100 transition-colors cursor-pointer font-semibold flex-shrink-0"
                  onClick={() => {
                    window.scrollTo(0, 0);
                  }}
                >
                  Home
                </div>
                <div
                  className="whitespace-nowrap p-2 rounded-xl text-[#202020] hover:bg-gray-100 transition-colors cursor-pointer font-semibold flex-shrink-0"
                  onClick={() => {
                    const { top } = document
                      .getElementById("howItWorks")
                      .getBoundingClientRect();
                    window.scrollTo(0, window.scrollY + top - 100);
                  }}
                >
                  How it Works
                </div>
                <div className="p-2 h-full rounded-xl text-[#202020] cursor-pointer font-semibold">
                  <a
                    href="https://coded-estate.gitbook.io/coded-estate/"
                    target="blank"
                  >
                    Documentation
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-3">
                <a href="https://discord.gg/fWfgQA8K6F" target="blank">
                  <svg
                    className="cursor-pointer"
                    width="23"
                    height="22"
                    viewBox="0 0 23 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9.41985 9.229C8.79285 9.229 8.29785 9.779 8.29785 10.45C8.29785 11.121 8.80385 11.671 9.41985 11.671C10.0469 11.671 10.5419 11.121 10.5419 10.45C10.5529 9.779 10.0469 9.229 9.41985 9.229ZM13.4349 9.229C12.8079 9.229 12.3129 9.779 12.3129 10.45C12.3129 11.121 12.8189 11.671 13.4349 11.671C14.0619 11.671 14.5569 11.121 14.5569 10.45C14.5569 9.779 14.0619 9.229 13.4349 9.229Z"
                      fill="#202020"
                    />
                    <path
                      d="M18.7804 0H4.0404C2.7974 0 1.7854 1.012 1.7854 2.266V17.138C1.7854 18.392 2.7974 19.404 4.0404 19.404H16.5144L15.9314 17.369L17.3394 18.678L18.6704 19.91L21.0354 22V2.266C21.0354 1.012 20.0234 0 18.7804 0ZM14.5344 14.366C14.5344 14.366 14.1384 13.893 13.8084 13.475C15.2494 13.068 15.7994 12.166 15.7994 12.166C15.3484 12.463 14.9194 12.672 14.5344 12.815C13.9844 13.046 13.4564 13.2 12.9394 13.288C11.8834 13.486 10.9154 13.431 10.0904 13.277C9.4634 13.156 8.9244 12.98 8.4734 12.804C8.2204 12.705 7.9454 12.584 7.6704 12.43C7.6374 12.408 7.6044 12.397 7.5714 12.375C7.5494 12.364 7.5384 12.353 7.5274 12.342C7.3294 12.232 7.2194 12.155 7.2194 12.155C7.2194 12.155 7.7474 13.035 9.1444 13.453C8.8144 13.871 8.4074 14.366 8.4074 14.366C5.9764 14.289 5.0524 12.694 5.0524 12.694C5.0524 9.152 6.6364 6.281 6.6364 6.281C8.2204 5.093 9.7274 5.126 9.7274 5.126L9.8374 5.258C7.8574 5.83 6.9444 6.699 6.9444 6.699C6.9444 6.699 7.1864 6.567 7.5934 6.38C8.7704 5.863 9.7054 5.72 10.0904 5.687C10.1564 5.676 10.2114 5.665 10.2774 5.665C10.9484 5.577 11.7074 5.555 12.4994 5.643C13.5444 5.764 14.6664 6.072 15.8104 6.699C15.8104 6.699 14.9414 5.874 13.0714 5.302L13.2254 5.126C13.2254 5.126 14.7324 5.093 16.3164 6.281C16.3164 6.281 17.9004 9.152 17.9004 12.694C17.9004 12.694 16.9654 14.289 14.5344 14.366Z"
                      fill="#202020"
                    />
                  </svg>
                </a>
                <a
                  href="https://x.com/codedestate?s=21&t=5OdxYhHLF31Z8VwzP3lI0g"
                  target="blank"
                >
                  <svg
                    className="cursor-pointer"
                    width="25"
                    height="22"
                    viewBox="0 0 25 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.176 3H20.9362L14.9061 9.77743L22 19H16.4456L12.0951 13.4065L7.11724 19H4.35543L10.8052 11.7508L4 3H9.69542L13.6278 8.11263L18.176 3ZM17.2074 17.3754H18.7367L8.86443 4.53927H7.22319L17.2074 17.3754Z"
                      fill="#202020"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          {/* </Fade> */}

          <div className="relative">
            {/* <Fade> */}
            <svg
              className="w-full sm:h-max h-[36px]"
              width="1420"
              height="117"
              viewBox="0 0 1420 117"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M81.8141 179.344C66.3453 179.344 52.4781 175.828 40.2125 168.797C27.9469 161.766 18.2594 151.57 11.15 138.211C4.04065 124.852 0.485962 108.719 0.485962 89.8125C0.485962 70.75 4.04065 54.5391 11.15 41.1797C18.3375 27.7422 28.0641 17.5469 40.3297 10.5938C52.6735 3.5625 66.5016 0.046875 81.8141 0.046875C91.9703 0.046875 101.384 1.49219 110.056 4.38281C118.728 7.19531 126.384 11.3359 133.025 16.8047C139.744 22.1953 145.213 28.8359 149.431 36.7266C153.65 44.5391 156.345 53.4844 157.517 63.5625H120.252C119.548 58.7969 118.142 54.5 116.033 50.6719C114.002 46.8437 111.306 43.6016 107.947 40.9453C104.666 38.2891 100.877 36.2578 96.5797 34.8516C92.361 33.3672 87.7125 32.625 82.6344 32.625C73.7281 32.625 65.8766 34.8906 59.0797 39.4219C52.361 43.875 47.1266 50.3594 43.3766 58.875C39.7047 67.3125 37.8688 77.625 37.8688 89.8125C37.8688 102.234 39.7438 112.703 43.4938 121.219C47.2438 129.656 52.4781 136.023 59.1969 140.32C65.9156 144.617 73.6891 146.766 82.5172 146.766C87.4391 146.766 92.0094 146.102 96.2281 144.773C100.447 143.445 104.197 141.531 107.478 139.031C110.759 136.531 113.494 133.484 115.681 129.891C117.947 126.219 119.47 122.039 120.252 117.352H157.517C156.58 125.398 154.197 133.133 150.369 140.555C146.619 147.977 141.502 154.617 135.017 160.477C128.533 166.258 120.838 170.867 111.931 174.305C103.025 177.664 92.986 179.344 81.8141 179.344ZM229.944 179.578C216.741 179.578 205.295 176.766 195.608 171.141C185.998 165.438 178.577 157.547 173.342 147.469C168.186 137.312 165.608 125.516 165.608 112.078C165.608 98.4844 168.186 86.6484 173.342 76.5703C178.577 66.4141 185.998 58.5234 195.608 52.8984C205.295 47.1953 216.741 44.3438 229.944 44.3438C243.225 44.3438 254.67 47.1953 264.28 52.8984C273.967 58.5234 281.389 66.4141 286.545 76.5703C291.78 86.6484 294.397 98.4844 294.397 112.078C294.397 125.516 291.78 137.312 286.545 147.469C281.389 157.547 273.967 165.438 264.28 171.141C254.67 176.766 243.225 179.578 229.944 179.578ZM230.178 151.219C236.194 151.219 241.233 149.539 245.295 146.18C249.358 142.742 252.405 138.055 254.436 132.117C256.545 126.18 257.6 119.422 257.6 111.844C257.6 104.188 256.545 97.4297 254.436 91.5703C252.405 85.7109 249.358 81.1016 245.295 77.7422C241.233 74.3828 236.194 72.7031 230.178 72.7031C224.084 72.7031 218.967 74.3828 214.827 77.7422C210.764 81.1016 207.678 85.7109 205.569 91.5703C203.538 97.4297 202.522 104.188 202.522 111.844C202.522 119.422 203.538 126.18 205.569 132.117C207.678 138.055 210.764 142.742 214.827 146.18C218.967 149.539 224.084 151.219 230.178 151.219ZM353.464 179.109C343.464 179.109 334.441 176.531 326.394 171.375C318.347 166.219 311.98 158.641 307.292 148.641C302.605 138.562 300.261 126.258 300.261 111.727C300.261 96.7266 302.683 84.2266 307.527 74.2266C312.37 64.2266 318.816 56.7656 326.863 51.8438C334.909 46.8437 343.698 44.3438 353.23 44.3438C360.573 44.3438 366.706 45.5938 371.628 48.0938C376.55 50.5156 380.534 53.5625 383.581 57.2344C386.628 60.9062 388.933 64.5391 390.495 68.1328H391.55V2.39062H427.878V177H392.136V156.023H390.495C388.855 159.617 386.472 163.211 383.347 166.805C380.222 170.32 376.198 173.25 371.277 175.594C366.433 177.938 360.495 179.109 353.464 179.109ZM364.831 150.281C370.691 150.281 375.652 148.68 379.714 145.477C383.855 142.195 386.98 137.664 389.089 131.883C391.277 126.102 392.37 119.344 392.37 111.609C392.37 103.797 391.316 97.0391 389.206 91.3359C387.097 85.5547 383.972 81.1016 379.831 77.9766C375.691 74.7734 370.691 73.1719 364.831 73.1719C358.894 73.1719 353.894 74.8125 349.831 78.0938C345.769 81.375 342.683 85.9062 340.573 91.6875C338.464 97.3906 337.409 104.031 337.409 111.609C337.409 119.188 338.464 125.906 340.573 131.766C342.683 137.547 345.769 142.078 349.831 145.359C353.972 148.641 358.972 150.281 364.831 150.281ZM503.938 179.578C490.5 179.578 478.898 176.844 469.133 171.375C459.367 165.906 451.867 158.133 446.633 148.055C441.477 137.898 438.898 125.906 438.898 112.078C438.898 98.6406 441.477 86.8438 446.633 76.6875C451.867 66.5312 459.211 58.6016 468.664 52.8984C478.195 47.1953 489.367 44.3438 502.18 44.3438C510.852 44.3438 518.938 45.75 526.438 48.5625C533.938 51.2969 540.5 55.4375 546.125 60.9844C551.75 66.4531 556.125 73.3672 559.25 81.7266C562.375 90.0078 563.938 99.7344 563.938 110.906V120.75H453.313V98.3672H546.359L529.484 104.227C529.484 97.5859 528.469 91.8047 526.438 86.8828C524.406 81.9609 521.359 78.1719 517.297 75.5156C513.313 72.7812 508.352 71.4141 502.414 71.4141C496.477 71.4141 491.438 72.7812 487.297 75.5156C483.234 78.25 480.109 81.9609 477.922 86.6484C475.734 91.3359 474.641 96.7266 474.641 102.82V118.641C474.641 125.75 475.891 131.844 478.391 136.922C480.891 141.922 484.367 145.789 488.82 148.523C493.352 151.18 498.547 152.508 504.406 152.508C508.469 152.508 512.141 151.922 515.422 150.75C518.703 149.578 521.516 147.859 523.859 145.594C526.281 143.328 528.078 140.594 529.25 137.391L562.766 139.617C561.125 147.664 557.688 154.695 552.453 160.711C547.297 166.648 540.617 171.297 532.414 174.656C524.211 177.938 514.719 179.578 503.938 179.578ZM622.536 179.109C612.536 179.109 603.513 176.531 595.466 171.375C587.419 166.219 581.052 158.641 576.364 148.641C571.677 138.562 569.333 126.258 569.333 111.727C569.333 96.7266 571.755 84.2266 576.598 74.2266C581.442 64.2266 587.888 56.7656 595.934 51.8438C603.981 46.8437 612.77 44.3438 622.302 44.3438C629.645 44.3438 635.778 45.5938 640.7 48.0938C645.622 50.5156 649.606 53.5625 652.653 57.2344C655.7 60.9062 658.005 64.5391 659.567 68.1328H660.622V2.39062H696.95V177H661.208V156.023H659.567C657.927 159.617 655.544 163.211 652.419 166.805C649.294 170.32 645.27 173.25 640.348 175.594C635.505 177.938 629.567 179.109 622.536 179.109ZM633.903 150.281C639.763 150.281 644.723 148.68 648.786 145.477C652.927 142.195 656.052 137.664 658.161 131.883C660.348 126.102 661.442 119.344 661.442 111.609C661.442 103.797 660.388 97.0391 658.278 91.3359C656.169 85.5547 653.044 81.1016 648.903 77.9766C644.763 74.7734 639.763 73.1719 633.903 73.1719C627.966 73.1719 622.966 74.8125 618.903 78.0938C614.841 81.375 611.755 85.9062 609.645 91.6875C607.536 97.3906 606.481 104.031 606.481 111.609C606.481 119.188 607.536 125.906 609.645 131.766C611.755 137.547 614.841 142.078 618.903 145.359C623.044 148.641 628.044 150.281 633.903 150.281ZM756.959 177V2.39062H874.616V32.8594H793.756V73.875H868.522V103.758H793.756V146.531H874.85V177H756.959ZM999.542 83.3672L966.378 85.3594C965.519 81.2188 963.214 77.6641 959.464 74.6953C955.714 71.6484 950.675 70.125 944.347 70.125C938.722 70.125 933.995 71.2969 930.167 73.6406C926.417 75.9844 924.542 79.1094 924.542 83.0156C924.542 86.1406 925.753 88.8359 928.175 91.1016C930.675 93.2891 934.933 95.0078 940.948 96.2578L964.738 100.945C977.472 103.523 986.964 107.703 993.214 113.484C999.464 119.266 1002.59 126.883 1002.59 136.336C1002.59 145.008 1000.09 152.586 995.089 159.07C990.089 165.477 983.214 170.516 974.464 174.188C965.714 177.781 955.675 179.578 944.347 179.578C927.003 179.578 913.175 175.945 902.863 168.68C892.628 161.414 886.652 151.57 884.933 139.148L920.441 137.273C921.613 142.586 924.269 146.609 928.409 149.344C932.55 152.078 937.863 153.445 944.347 153.445C950.675 153.445 955.792 152.195 959.698 149.695C963.683 147.195 965.675 144.031 965.675 140.203C965.675 133.719 960.05 129.344 948.8 127.078L926.183 122.391C913.448 119.812 903.956 115.398 897.706 109.148C891.456 102.898 888.331 94.8906 888.331 85.125C888.331 76.6875 890.636 69.4219 895.245 63.3281C899.855 57.2344 906.3 52.5469 914.581 49.2656C922.941 45.9844 932.706 44.3438 943.878 44.3438C960.441 44.3438 973.448 47.8594 982.902 54.8906C992.433 61.8438 997.98 71.3359 999.542 83.3672ZM1082.52 45.9844V73.4062H1003.65V45.9844H1082.52ZM1021.58 14.8125H1057.79V136.688C1057.79 141.062 1058.77 144.305 1060.72 146.414C1062.67 148.445 1065.8 149.461 1070.09 149.461C1071.5 149.461 1073.06 149.344 1074.78 149.109C1076.5 148.875 1077.98 148.602 1079.23 148.289L1084.98 175.477C1080.99 176.648 1077.12 177.508 1073.38 178.055C1069.7 178.602 1066.07 178.875 1062.48 178.875C1049.43 178.875 1039.35 175.633 1032.24 169.148C1025.13 162.586 1021.58 153.367 1021.58 141.492V14.8125ZM1130.8 179.461C1122.52 179.461 1115.06 178.016 1108.42 175.125C1101.86 172.156 1096.7 167.781 1092.95 162C1089.2 156.219 1087.33 149.031 1087.33 140.438C1087.33 133.094 1088.65 127 1091.31 122.156C1093.97 117.234 1097.6 113.25 1102.21 110.203C1106.82 107.156 1112.05 104.852 1117.91 103.289C1123.77 101.727 1129.98 100.633 1136.54 100.008C1144.12 99.3047 1150.22 98.6016 1154.83 97.8984C1159.43 97.1953 1162.79 96.1406 1164.9 94.7344C1167.09 93.25 1168.18 91.1406 1168.18 88.4062V87.8203C1168.18 82.4297 1166.47 78.25 1163.03 75.2812C1159.67 72.3125 1154.9 70.8281 1148.73 70.8281C1142.25 70.8281 1137.05 72.2734 1133.15 75.1641C1129.32 77.9766 1126.78 81.5703 1125.53 85.9453L1091.9 83.25C1093.61 75.2812 1096.97 68.4062 1101.97 62.625C1106.97 56.7656 1113.42 52.2734 1121.31 49.1484C1129.28 45.9453 1138.5 44.3438 1148.97 44.3438C1156.23 44.3438 1163.18 45.2031 1169.83 46.9219C1176.47 48.6406 1182.36 51.2969 1187.52 54.8906C1192.75 58.4062 1196.9 62.9766 1199.94 68.6016C1202.99 74.2266 1204.51 80.9062 1204.51 88.6406V177H1169.94V158.719H1169C1166.9 162.859 1164.08 166.492 1160.57 169.617C1157.05 172.664 1152.83 175.086 1147.91 176.883C1142.99 178.602 1137.29 179.461 1130.8 179.461ZM1141.23 154.383C1146.54 154.383 1151.23 153.328 1155.29 151.219C1159.43 149.031 1162.64 146.141 1164.9 142.547C1167.25 138.875 1168.42 134.773 1168.42 130.242V116.297C1167.33 117 1165.76 117.664 1163.73 118.289C1161.78 118.914 1159.59 119.461 1157.17 119.93C1154.75 120.398 1152.33 120.828 1149.9 121.219C1147.48 121.531 1145.29 121.844 1143.34 122.156C1139.04 122.781 1135.29 123.797 1132.09 125.203C1128.89 126.531 1126.39 128.367 1124.59 130.711C1122.87 132.977 1122.01 135.828 1122.01 139.266C1122.01 144.188 1123.81 147.938 1127.4 150.516C1131 153.094 1135.61 154.383 1141.23 154.383ZM1290.42 45.9844V73.4062H1211.55V45.9844H1290.42ZM1229.48 14.8125H1265.69V136.688C1265.69 141.062 1266.67 144.305 1268.62 146.414C1270.57 148.445 1273.7 149.461 1277.99 149.461C1279.4 149.461 1280.96 149.344 1282.68 149.109C1284.4 148.875 1285.88 148.602 1287.13 148.289L1292.88 175.477C1288.89 176.648 1285.03 177.508 1281.28 178.055C1277.6 178.602 1273.97 178.875 1270.38 178.875C1257.33 178.875 1247.25 175.633 1240.14 169.148C1233.03 162.586 1229.48 153.367 1229.48 141.492V14.8125ZM1359.68 179.578C1346.24 179.578 1334.64 176.844 1324.87 171.375C1315.11 165.906 1307.61 158.133 1302.37 148.055C1297.22 137.898 1294.64 125.906 1294.64 112.078C1294.64 98.6406 1297.22 86.8438 1302.37 76.6875C1307.61 66.5312 1314.95 58.6016 1324.4 52.8984C1333.94 47.1953 1345.11 44.3438 1357.92 44.3438C1366.59 44.3438 1374.68 45.75 1382.18 48.5625C1389.68 51.2969 1396.24 55.4375 1401.87 60.9844C1407.49 66.4531 1411.87 73.3672 1414.99 81.7266C1418.12 90.0078 1419.68 99.7344 1419.68 110.906V120.75H1309.05V98.3672H1402.1L1385.22 104.227C1385.22 97.5859 1384.21 91.8047 1382.18 86.8828C1380.15 81.9609 1377.1 78.1719 1373.04 75.5156C1369.05 72.7812 1364.09 71.4141 1358.15 71.4141C1352.22 71.4141 1347.18 72.7812 1343.04 75.5156C1338.97 78.25 1335.85 81.9609 1333.66 86.6484C1331.47 91.3359 1330.38 96.7266 1330.38 102.82V118.641C1330.38 125.75 1331.63 131.844 1334.13 136.922C1336.63 141.922 1340.11 145.789 1344.56 148.523C1349.09 151.18 1354.29 152.508 1360.15 152.508C1364.21 152.508 1367.88 151.922 1371.16 150.75C1374.44 149.578 1377.26 147.859 1379.6 145.594C1382.02 143.328 1383.82 140.594 1384.99 137.391L1418.51 139.617C1416.87 147.664 1413.43 154.695 1408.19 160.711C1403.04 166.648 1396.36 171.297 1388.15 174.656C1379.95 177.938 1370.46 179.578 1359.68 179.578Z"
                fill="#5B1DEE"
              />
              <path
                d="M81.8141 179.344C66.3453 179.344 52.4781 175.828 40.2125 168.797C27.9469 161.766 18.2594 151.57 11.15 138.211C4.04065 124.852 0.485962 108.719 0.485962 89.8125C0.485962 70.75 4.04065 54.5391 11.15 41.1797C18.3375 27.7422 28.0641 17.5469 40.3297 10.5938C52.6735 3.5625 66.5016 0.046875 81.8141 0.046875C91.9703 0.046875 101.384 1.49219 110.056 4.38281C118.728 7.19531 126.384 11.3359 133.025 16.8047C139.744 22.1953 145.213 28.8359 149.431 36.7266C153.65 44.5391 156.345 53.4844 157.517 63.5625H120.252C119.548 58.7969 118.142 54.5 116.033 50.6719C114.002 46.8437 111.306 43.6016 107.947 40.9453C104.666 38.2891 100.877 36.2578 96.5797 34.8516C92.361 33.3672 87.7125 32.625 82.6344 32.625C73.7281 32.625 65.8766 34.8906 59.0797 39.4219C52.361 43.875 47.1266 50.3594 43.3766 58.875C39.7047 67.3125 37.8688 77.625 37.8688 89.8125C37.8688 102.234 39.7438 112.703 43.4938 121.219C47.2438 129.656 52.4781 136.023 59.1969 140.32C65.9156 144.617 73.6891 146.766 82.5172 146.766C87.4391 146.766 92.0094 146.102 96.2281 144.773C100.447 143.445 104.197 141.531 107.478 139.031C110.759 136.531 113.494 133.484 115.681 129.891C117.947 126.219 119.47 122.039 120.252 117.352H157.517C156.58 125.398 154.197 133.133 150.369 140.555C146.619 147.977 141.502 154.617 135.017 160.477C128.533 166.258 120.838 170.867 111.931 174.305C103.025 177.664 92.986 179.344 81.8141 179.344ZM229.944 179.578C216.741 179.578 205.295 176.766 195.608 171.141C185.998 165.438 178.577 157.547 173.342 147.469C168.186 137.312 165.608 125.516 165.608 112.078C165.608 98.4844 168.186 86.6484 173.342 76.5703C178.577 66.4141 185.998 58.5234 195.608 52.8984C205.295 47.1953 216.741 44.3438 229.944 44.3438C243.225 44.3438 254.67 47.1953 264.28 52.8984C273.967 58.5234 281.389 66.4141 286.545 76.5703C291.78 86.6484 294.397 98.4844 294.397 112.078C294.397 125.516 291.78 137.312 286.545 147.469C281.389 157.547 273.967 165.438 264.28 171.141C254.67 176.766 243.225 179.578 229.944 179.578ZM230.178 151.219C236.194 151.219 241.233 149.539 245.295 146.18C249.358 142.742 252.405 138.055 254.436 132.117C256.545 126.18 257.6 119.422 257.6 111.844C257.6 104.188 256.545 97.4297 254.436 91.5703C252.405 85.7109 249.358 81.1016 245.295 77.7422C241.233 74.3828 236.194 72.7031 230.178 72.7031C224.084 72.7031 218.967 74.3828 214.827 77.7422C210.764 81.1016 207.678 85.7109 205.569 91.5703C203.538 97.4297 202.522 104.188 202.522 111.844C202.522 119.422 203.538 126.18 205.569 132.117C207.678 138.055 210.764 142.742 214.827 146.18C218.967 149.539 224.084 151.219 230.178 151.219ZM353.464 179.109C343.464 179.109 334.441 176.531 326.394 171.375C318.347 166.219 311.98 158.641 307.292 148.641C302.605 138.562 300.261 126.258 300.261 111.727C300.261 96.7266 302.683 84.2266 307.527 74.2266C312.37 64.2266 318.816 56.7656 326.863 51.8438C334.909 46.8437 343.698 44.3438 353.23 44.3438C360.573 44.3438 366.706 45.5938 371.628 48.0938C376.55 50.5156 380.534 53.5625 383.581 57.2344C386.628 60.9062 388.933 64.5391 390.495 68.1328H391.55V2.39062H427.878V177H392.136V156.023H390.495C388.855 159.617 386.472 163.211 383.347 166.805C380.222 170.32 376.198 173.25 371.277 175.594C366.433 177.938 360.495 179.109 353.464 179.109ZM364.831 150.281C370.691 150.281 375.652 148.68 379.714 145.477C383.855 142.195 386.98 137.664 389.089 131.883C391.277 126.102 392.37 119.344 392.37 111.609C392.37 103.797 391.316 97.0391 389.206 91.3359C387.097 85.5547 383.972 81.1016 379.831 77.9766C375.691 74.7734 370.691 73.1719 364.831 73.1719C358.894 73.1719 353.894 74.8125 349.831 78.0938C345.769 81.375 342.683 85.9062 340.573 91.6875C338.464 97.3906 337.409 104.031 337.409 111.609C337.409 119.188 338.464 125.906 340.573 131.766C342.683 137.547 345.769 142.078 349.831 145.359C353.972 148.641 358.972 150.281 364.831 150.281ZM503.938 179.578C490.5 179.578 478.898 176.844 469.133 171.375C459.367 165.906 451.867 158.133 446.633 148.055C441.477 137.898 438.898 125.906 438.898 112.078C438.898 98.6406 441.477 86.8438 446.633 76.6875C451.867 66.5312 459.211 58.6016 468.664 52.8984C478.195 47.1953 489.367 44.3438 502.18 44.3438C510.852 44.3438 518.938 45.75 526.438 48.5625C533.938 51.2969 540.5 55.4375 546.125 60.9844C551.75 66.4531 556.125 73.3672 559.25 81.7266C562.375 90.0078 563.938 99.7344 563.938 110.906V120.75H453.313V98.3672H546.359L529.484 104.227C529.484 97.5859 528.469 91.8047 526.438 86.8828C524.406 81.9609 521.359 78.1719 517.297 75.5156C513.313 72.7812 508.352 71.4141 502.414 71.4141C496.477 71.4141 491.438 72.7812 487.297 75.5156C483.234 78.25 480.109 81.9609 477.922 86.6484C475.734 91.3359 474.641 96.7266 474.641 102.82V118.641C474.641 125.75 475.891 131.844 478.391 136.922C480.891 141.922 484.367 145.789 488.82 148.523C493.352 151.18 498.547 152.508 504.406 152.508C508.469 152.508 512.141 151.922 515.422 150.75C518.703 149.578 521.516 147.859 523.859 145.594C526.281 143.328 528.078 140.594 529.25 137.391L562.766 139.617C561.125 147.664 557.688 154.695 552.453 160.711C547.297 166.648 540.617 171.297 532.414 174.656C524.211 177.938 514.719 179.578 503.938 179.578ZM622.536 179.109C612.536 179.109 603.513 176.531 595.466 171.375C587.419 166.219 581.052 158.641 576.364 148.641C571.677 138.562 569.333 126.258 569.333 111.727C569.333 96.7266 571.755 84.2266 576.598 74.2266C581.442 64.2266 587.888 56.7656 595.934 51.8438C603.981 46.8437 612.77 44.3438 622.302 44.3438C629.645 44.3438 635.778 45.5938 640.7 48.0938C645.622 50.5156 649.606 53.5625 652.653 57.2344C655.7 60.9062 658.005 64.5391 659.567 68.1328H660.622V2.39062H696.95V177H661.208V156.023H659.567C657.927 159.617 655.544 163.211 652.419 166.805C649.294 170.32 645.27 173.25 640.348 175.594C635.505 177.938 629.567 179.109 622.536 179.109ZM633.903 150.281C639.763 150.281 644.723 148.68 648.786 145.477C652.927 142.195 656.052 137.664 658.161 131.883C660.348 126.102 661.442 119.344 661.442 111.609C661.442 103.797 660.388 97.0391 658.278 91.3359C656.169 85.5547 653.044 81.1016 648.903 77.9766C644.763 74.7734 639.763 73.1719 633.903 73.1719C627.966 73.1719 622.966 74.8125 618.903 78.0938C614.841 81.375 611.755 85.9062 609.645 91.6875C607.536 97.3906 606.481 104.031 606.481 111.609C606.481 119.188 607.536 125.906 609.645 131.766C611.755 137.547 614.841 142.078 618.903 145.359C623.044 148.641 628.044 150.281 633.903 150.281ZM756.959 177V2.39062H874.616V32.8594H793.756V73.875H868.522V103.758H793.756V146.531H874.85V177H756.959ZM999.542 83.3672L966.378 85.3594C965.519 81.2188 963.214 77.6641 959.464 74.6953C955.714 71.6484 950.675 70.125 944.347 70.125C938.722 70.125 933.995 71.2969 930.167 73.6406C926.417 75.9844 924.542 79.1094 924.542 83.0156C924.542 86.1406 925.753 88.8359 928.175 91.1016C930.675 93.2891 934.933 95.0078 940.948 96.2578L964.738 100.945C977.472 103.523 986.964 107.703 993.214 113.484C999.464 119.266 1002.59 126.883 1002.59 136.336C1002.59 145.008 1000.09 152.586 995.089 159.07C990.089 165.477 983.214 170.516 974.464 174.188C965.714 177.781 955.675 179.578 944.347 179.578C927.003 179.578 913.175 175.945 902.863 168.68C892.628 161.414 886.652 151.57 884.933 139.148L920.441 137.273C921.613 142.586 924.269 146.609 928.409 149.344C932.55 152.078 937.863 153.445 944.347 153.445C950.675 153.445 955.792 152.195 959.698 149.695C963.683 147.195 965.675 144.031 965.675 140.203C965.675 133.719 960.05 129.344 948.8 127.078L926.183 122.391C913.448 119.812 903.956 115.398 897.706 109.148C891.456 102.898 888.331 94.8906 888.331 85.125C888.331 76.6875 890.636 69.4219 895.245 63.3281C899.855 57.2344 906.3 52.5469 914.581 49.2656C922.941 45.9844 932.706 44.3438 943.878 44.3438C960.441 44.3438 973.448 47.8594 982.902 54.8906C992.433 61.8438 997.98 71.3359 999.542 83.3672ZM1082.52 45.9844V73.4062H1003.65V45.9844H1082.52ZM1021.58 14.8125H1057.79V136.688C1057.79 141.062 1058.77 144.305 1060.72 146.414C1062.67 148.445 1065.8 149.461 1070.09 149.461C1071.5 149.461 1073.06 149.344 1074.78 149.109C1076.5 148.875 1077.98 148.602 1079.23 148.289L1084.98 175.477C1080.99 176.648 1077.12 177.508 1073.38 178.055C1069.7 178.602 1066.07 178.875 1062.48 178.875C1049.43 178.875 1039.35 175.633 1032.24 169.148C1025.13 162.586 1021.58 153.367 1021.58 141.492V14.8125ZM1130.8 179.461C1122.52 179.461 1115.06 178.016 1108.42 175.125C1101.86 172.156 1096.7 167.781 1092.95 162C1089.2 156.219 1087.33 149.031 1087.33 140.438C1087.33 133.094 1088.65 127 1091.31 122.156C1093.97 117.234 1097.6 113.25 1102.21 110.203C1106.82 107.156 1112.05 104.852 1117.91 103.289C1123.77 101.727 1129.98 100.633 1136.54 100.008C1144.12 99.3047 1150.22 98.6016 1154.83 97.8984C1159.43 97.1953 1162.79 96.1406 1164.9 94.7344C1167.09 93.25 1168.18 91.1406 1168.18 88.4062V87.8203C1168.18 82.4297 1166.47 78.25 1163.03 75.2812C1159.67 72.3125 1154.9 70.8281 1148.73 70.8281C1142.25 70.8281 1137.05 72.2734 1133.15 75.1641C1129.32 77.9766 1126.78 81.5703 1125.53 85.9453L1091.9 83.25C1093.61 75.2812 1096.97 68.4062 1101.97 62.625C1106.97 56.7656 1113.42 52.2734 1121.31 49.1484C1129.28 45.9453 1138.5 44.3438 1148.97 44.3438C1156.23 44.3438 1163.18 45.2031 1169.83 46.9219C1176.47 48.6406 1182.36 51.2969 1187.52 54.8906C1192.75 58.4062 1196.9 62.9766 1199.94 68.6016C1202.99 74.2266 1204.51 80.9062 1204.51 88.6406V177H1169.94V158.719H1169C1166.9 162.859 1164.08 166.492 1160.57 169.617C1157.05 172.664 1152.83 175.086 1147.91 176.883C1142.99 178.602 1137.29 179.461 1130.8 179.461ZM1141.23 154.383C1146.54 154.383 1151.23 153.328 1155.29 151.219C1159.43 149.031 1162.64 146.141 1164.9 142.547C1167.25 138.875 1168.42 134.773 1168.42 130.242V116.297C1167.33 117 1165.76 117.664 1163.73 118.289C1161.78 118.914 1159.59 119.461 1157.17 119.93C1154.75 120.398 1152.33 120.828 1149.9 121.219C1147.48 121.531 1145.29 121.844 1143.34 122.156C1139.04 122.781 1135.29 123.797 1132.09 125.203C1128.89 126.531 1126.39 128.367 1124.59 130.711C1122.87 132.977 1122.01 135.828 1122.01 139.266C1122.01 144.188 1123.81 147.938 1127.4 150.516C1131 153.094 1135.61 154.383 1141.23 154.383ZM1290.42 45.9844V73.4062H1211.55V45.9844H1290.42ZM1229.48 14.8125H1265.69V136.688C1265.69 141.062 1266.67 144.305 1268.62 146.414C1270.57 148.445 1273.7 149.461 1277.99 149.461C1279.4 149.461 1280.96 149.344 1282.68 149.109C1284.4 148.875 1285.88 148.602 1287.13 148.289L1292.88 175.477C1288.89 176.648 1285.03 177.508 1281.28 178.055C1277.6 178.602 1273.97 178.875 1270.38 178.875C1257.33 178.875 1247.25 175.633 1240.14 169.148C1233.03 162.586 1229.48 153.367 1229.48 141.492V14.8125ZM1359.68 179.578C1346.24 179.578 1334.64 176.844 1324.87 171.375C1315.11 165.906 1307.61 158.133 1302.37 148.055C1297.22 137.898 1294.64 125.906 1294.64 112.078C1294.64 98.6406 1297.22 86.8438 1302.37 76.6875C1307.61 66.5312 1314.95 58.6016 1324.4 52.8984C1333.94 47.1953 1345.11 44.3438 1357.92 44.3438C1366.59 44.3438 1374.68 45.75 1382.18 48.5625C1389.68 51.2969 1396.24 55.4375 1401.87 60.9844C1407.49 66.4531 1411.87 73.3672 1414.99 81.7266C1418.12 90.0078 1419.68 99.7344 1419.68 110.906V120.75H1309.05V98.3672H1402.1L1385.22 104.227C1385.22 97.5859 1384.21 91.8047 1382.18 86.8828C1380.15 81.9609 1377.1 78.1719 1373.04 75.5156C1369.05 72.7812 1364.09 71.4141 1358.15 71.4141C1352.22 71.4141 1347.18 72.7812 1343.04 75.5156C1338.97 78.25 1335.85 81.9609 1333.66 86.6484C1331.47 91.3359 1330.38 96.7266 1330.38 102.82V118.641C1330.38 125.75 1331.63 131.844 1334.13 136.922C1336.63 141.922 1340.11 145.789 1344.56 148.523C1349.09 151.18 1354.29 152.508 1360.15 152.508C1364.21 152.508 1367.88 151.922 1371.16 150.75C1374.44 149.578 1377.26 147.859 1379.6 145.594C1382.02 143.328 1383.82 140.594 1384.99 137.391L1418.51 139.617C1416.87 147.664 1413.43 154.695 1408.19 160.711C1403.04 166.648 1396.36 171.297 1388.15 174.656C1379.95 177.938 1370.46 179.578 1359.68 179.578Z"
                fill="url(#paint0_linear_1402_59434)"
                fill-opacity="0.18"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1402_59434"
                  x1="708.5"
                  y1="-30"
                  x2="708.5"
                  y2="125"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="white" />
                  <stop offset="1" stop-color="white" stop-opacity="0" />
                </linearGradient>
              </defs>
            </svg>
            {/* </Fade> */}
            <div className="flex absolute w-full sm:top-[60px] top-[10px]">
              <div className="mx-auto bg-white px-6 text-[12px] sm:text-[18px]">
                Copyright © 2025 CodedEstate
              </div>
            </div>
          </div>

          <Tooltip
            id="my-tooltip"
            content="Only available on desktop"
            style={{ borderRadius: "4px", padding: "6px" }}
          />
          
          {/* Wallet Submit Modal */}
          <WalletSubmitModal 
            isOpen={walletModalOpen}
            onClose={() => setWalletModalOpen(false)}
            connectedWallet={connectedWallet}
            onConnectWallet={setConnectedWallet}
            onModalStateChange={setIsAnyModalOpen}
          />
          
          {/* Toast Container */}
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </div>
      )}
    </>
  );
}

export default App;